import {
  Award,
  BarChart,
  BookOpen,
  CheckCircle,
  Dock,
  DollarSign,
  File,
  Globe2,
  GraduationCapIcon,
  Search,
  TrendingUp,
  Users2,
  Wallet,
  Home as LucideHome,
  LayoutDashboard,
  Heart as LucideHeart,
  Calendar as LucideCalendar,
  Briefcase as LucideBriefcase,
  FileText,
  Bot,
  GaugeCircleIcon,
  HandIcon,
  Text,
  Handshake,
  FileIcon,
} from "lucide-react";
import {
  AboutUs,
  ApplicationIcon,
  AustraliaIcon,
  BackLogsDocIcon,
  BlueEducationCap,
  Briefcase,
  Building,
  CanadaIcon,
  CheckIcon,
  Computer,
  ContactIcon,
  ContactUsIcon,
  CyprusIcon,
  DashboardIcon,
  Document,
  DocumentIcon,
  DubaiIcon,
  EconomicsIcon,
  EducationCap,
  EducationLoan,
  EnglishIcon,
  EstoniaIcon,
  EuropeIcon,
  Facebook,
  Favourites,
  Fee,
  FeeTransfer,
  FinlandIcon,
  FranceIcon,
  Gavel,
  GermanyIcons,
  Globe,
  GlobeIcon,
  GraduationCap,
  GreeceIcon,
  GreenAirplaneIcon,
  GreenClockIcon,
  GreenPercent,
  Guardain,
  HandWithGlobe,
  Heart,
  Home,
  HungaryIcon,
  Instagram,
  InterviewPreparation,
  IrelandIcon,
  ItalyIcon,
  LatviaIcon,
  Leaf,
  LinkedIn,
  MalaysiaIcon,
  MaltaIcon,
  NetherLandsIcon,
  NewZealandIcon,
  Parent,
  Personal,
  PersonalGreen,
  PiChartIcon,
  PolandIcon,
  SecorityIcon,
  Services,
  Sessions,
  SingaporeIcon,
  SlidersHorizontalIcon,
  SouthKoreaIcon,
  SpainIcon,
  Spouse,
  StudentWithBook,
  SwedenIcon,
  Theater,
  Travel,
  UKIcon,
  UploadDocs,
  USAIcon,
  User,
  Users,
  VisaProcessing,
  WhiteClockIcon,
  WhiteStarts,
  WorkPermitBag,
  WrenchMen,
  YouTube,
} from "./Icons";

const currentYear = new Date().getFullYear();

export const intakeOptions = [
  {
    id: 1,
    title: `${currentYear}`,
  },
  {
    id: 2,
    title: `${currentYear + 1}`,
  },
];

export const institutionOptions = [
  { id: 1, title: "Public" },
  { id: 2, title: "Private" },
  { id: 3, title: "Community" },
];

export const schoolBoard = [
  {
    id: "1",
    title: "BIEAP - Board of Intermediate Education (Andhra Pradesh)",
  },
  { id: "2", title: "AHSEC - Assam Higher Secondary Education Council" },
  { id: "3", title: "BSEAP - Board of Secondary Education (Andhra Pradesh)" },
  { id: "4", title: "SEBA - Board of Secondary Education Assam" },
  { id: "5", title: "Bihar Board - Bihar School Examination Board" },
  { id: "6", title: "BBOSE - Bihar Board of Open Schooling & Examination" },
  { id: "7", title: "CBSE - Central Board of Secondary Education" },
  { id: "8", title: "CGSOS - Chhatisgarh State Open School" },
  {
    id: "9",
    title: "CISCE - Council for the Indian School Certificate Examinations",
  },
  { id: "10", title: "UPSOSB - Uttar Pradesh State Open School Board" },
  { id: "11", title: "DBSE - Delhi Board of School Examination" },
  { id: "12", title: "DSOS - Delhi State Open School" },
  { id: "13", title: "ICSE - Indian Council of Secondary Education" },
  { id: "14", title: "BSES - Board of Secondary Education Sikkim" },
  {
    id: "15",
    title: "GBSHSE - Goa Board of Secondary and Higher Secondary Education",
  },
  {
    id: "16",
    title: "GSEB - Gujarat Secondary and Higher Secondary Education Board",
  },
  { id: "17", title: "BSEH - Board of School Education Haryana" },
  { id: "18", title: "GKV - Gurukula Kangri Vishwavidyalaya" },
  { id: "19", title: "HPBOSE - H. P. Board of School Education" },
  { id: "20", title: "JKBOSE - The J & K State Board of School Education" },
  { id: "21", title: "JKSOS - Jammu and Kashmir State Open School" },
  {
    id: "22",
    title: "Kerala Board - Kerala Board of Public Examination Kerala",
  },
  {
    id: "23",
    title: "KSEEB - Karnataka Secondary Education Examination Board",
  },
  { id: "24", title: "MPBSE - Board of Secondary Education, Madhya Pradesh" },
  {
    id: "25",
    title:
      "MSBSHSE - Maharashtra State Board of Secondary and Higher Secondary Education",
  },
  { id: "26", title: "MPSOS - M.P. State Open School Education Board" },
  { id: "27", title: "BSEM - Board of Secondary Education, Manipur" },
  {
    id: "28",
    title: "COHSEM - Council of Higher Secondary Education, Manipur",
  },
  { id: "29", title: "MBOSE - Meghalaya Board of School Education" },
  { id: "30", title: "MBSE - Mizoram Board of School Education" },
  { id: "31", title: "NBSE - Nagaland Board of School Education" },
  { id: "32", title: "CHSEO - Council of Higher Secondary Education, Odisha" },
  { id: "33", title: "PSEB - Punjab School Education Board" },
  { id: "34", title: "BSEO - Board of Secondary Education, Odisha" },
  { id: "35", title: "BOSER - Board of Secondary Education Rajasthan" },
  { id: "36", title: "RSOS - Rajasthan State Open School, Jaipur" },
  {
    id: "37",
    title: "SCBSETN - State Common Board of School Education, Tamil Nadu",
  },
  {
    id: "38",
    title: "TSBIE - Telangana State Board of Intermediate Education",
  },
  { id: "39", title: "BSETS - Board of Secondary Education, Telangana State" },
  { id: "40", title: "TBSE - Tripura Board of Secondary Education" },
  {
    id: "41",
    title: "UPMSP - U.P. Board of High School & Intermediate Education",
  },
  { id: "42", title: "UBSE - Board of School Education Uttarakhand" },
  { id: "43", title: "WBBSE - West Bengal Board of Secondary Education" },
  {
    id: "44",
    title: "WBCHSE - West Bengal Council of Higher Secondary Education",
  },
  { id: "45", title: "BOSSE - Board of Open Schooling & Skill Education" },
  { id: "46", title: "NIOS - National Institute of Open Schooling" },
];
export const pastQualification = [
  { id: 1, title: "12th" },
  { id: 2, title: "Bachelor" },
  { id: 3, title: "Certification" },
  { id: 4, title: "Diploma" },
  { id: 5, title: "Master" },
  { id: 6, title: "PG Diploma" },
  { id: 7, title: "PhD" },
];

export const highestQualification = [
  {
    id: 1,
    title: "12th",
  },
  {
    id: 2,
    title: "Diploma",
  },
  {
    id: 3,
    title: "Bachelor’s",
  },
  {
    id: 4,
    title: "PG Diploma",
  },
  {
    id: 5,
    title: "Master’s",
  },
  {
    id: 6,
    title: "PhD",
  },
];

export const academicRecords = [
  {
    id: 1,
    title: "12th",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
    ],
  },
  {
    id: 2,
    title: "Diploma",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
      {
        id: 3,
        title: "Diploma Marksheet",
        value: "diploma_marksheet",
      },
    ],
  },
  {
    id: 3,
    title: "Bachelor’s",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
      {
        id: 3,
        title: "Bachelor Marksheet",
        value: "bachelor_marksheet",
      },
      {
        id: 4,
        title: "Bachelor Transcript",
        value: "bachelor_transcript",
      },
    ],
  },
  {
    id: 4,
    title: "Master’s",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
      {
        id: 3,
        title: "Bachelor Marksheet",
        value: "bachelor_marksheet",
      },
      {
        id: 4,
        title: "Bachelor Transcript",
        value: "bachelor_transcript",
      },
      {
        id: 5,
        title: "Master Degree",
        value: "master_marksheet",
      },
      {
        id: 6,
        title: "Master Transcript",
        value: "master_transcript",
      },
    ],
  },
  {
    id: 5,
    title: "PG Diploma",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
      {
        id: 3,
        title: "Bachelor Marksheet",
        value: "bachelor_marksheet",
      },
      {
        id: 4,
        title: "Bachelor Transcript",
        value: "bachelor_transcript",
      },
    ],
  },
  {
    id: 6,
    title: "PhD",
    options: [
      {
        id: 1,
        title: "10th Marksheet",
        value: "10th_marksheet",
      },
      {
        id: 2,
        title: "12th Marksheet",
        value: "12th_marksheet",
      },
      {
        id: 3,
        title: "Bachelor Transcript",
        value: "bachelor_transcript",
      },
      {
        id: 4,
        title: "Bachelor Marksheet",
        value: "bachelor_marksheet",
      },
      {
        id: 5,
        title: "Master Degree",
        value: "master_marksheet",
      },
      {
        id: 6,
        title: "Master Transcript",
        value: "master_transcript",
      },
      {
        id: 7,
        title: "PhD Certificate",
        value: "phd_certificate",
      },
    ],
  },
];
export const gradingSystem = [
  { id: 1, title: "Percentage" },
  { id: 2, title: "CGPA out of 3" },
  { id: 3, title: "CGPA out of 4" },
  { id: 4, title: "CGPA out of 5" },
  { id: 5, title: "CGPA out of 7" },
  { id: 6, title: "CGPA out of 9" },
  { id: 7, title: "CGPA out of 10" },
];

export const streamOptions = [
  {
    id: 1,
    qualification: "10th",
    options: [],
  },
  {
    id: 2,
    qualification: "12th",
    options: [
      {
        id: 1,
        title: "Arts & Humanities",
      },
      {
        id: 2,
        title: "Commerce",
      },
      {
        id: 3,
        title: "Medical",
      },
      {
        id: 4,
        title: "Super-Medical",
      },
      {
        id: 5,
        title: "Non-Medical",
      },
    ],
  },
  {
    id: 3,
    qualification: "Diploma",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
  {
    id: 4,
    qualification: "Bachelor",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
  {
    id: 5,
    qualification: "PG-Diploma",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
  {
    id: 6,
    qualification: "Master",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
  {
    id: 7,
    qualification: "PhD",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
  {
    id: 8,
    qualification: "Certification",
    options: [
      {
        id: 0,
        title: "Agriculture",
      },
      {
        id: 1,
        title: "Arts and Humanities",
      },
      {
        id: 2,
        title: "Business and Management",
      },
      {
        id: 3,
        title: "Economics",
      },
      {
        id: 4,
        title: "Engineering",
      },
      {
        id: 5,
        title: "Finance",
      },
      {
        id: 6,
        title: "Hospitality and Tourism",
      },
      {
        id: 7,
        title: "Information Technology",
      },
      {
        id: 8,
        title: "Law",
      },
      {
        id: 9,
        title: "Medical and Healthcare",
      },
      {
        id: 10,
        title: "Natural Sciences",
      },
      {
        id: 11,
        title: "Social Science",
      },
      {
        id: 12,
        title: "Theoritical and Fundamental Sciences",
      },
    ],
  },
];

// get past 20 years
export const getLast20Years = (): { id: number; title: string }[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    title: (currentYear - i).toString(),
  }));
};

export const passingYear = getLast20Years();

export const eligibility = {
  country: "USA",
  AcademicDetails: [
    {
      qualification: "10th",
      stream: "Science",
      passingYear: "2020",
      gradingSystem: "Percentage",
      pastGrades: "85%",
    },
  ],
  EnglishProficiencyDetails: [
    {
      test: "IELTS",
      listeningScore: "7",
      readingScore: "7",
      writingScore: "7",
      speakingScore: "7",
    },
  ],
};

export const qualificationOptions = [
  { id: 1, priority: 1, title: "PhD" },
  { id: 2, priority: 2, title: "Master" },
  { id: 3, priority: 3, title: "PG Diploma" },
  { id: 4, priority: 4, title: "Bachelor" },
  { id: 5, priority: 5, title: "Diploma" },
  { id: 6, priority: 6, title: "Certification" },
  { id: 7, priority: 7, title: "12th" },
  { id: 8, priority: 8, title: "10th" },
];
export const languageTestOptions = [
  { id: 1, title: "IELTS" },
  { id: 2, title: "PTE" },
  { id: 3, title: "TOEFL" },
  { id: 4, title: "Duolingo" },
];
export const addQualificationsOptions = [
  {
    id: 1,
    placeHolder: "10th",
    options: [
      {
        id: 1,
        placeHolder: "Name of Board",
        options: [
          {
            id: 1,
            title: "CBSE",
          },
          {
            id: 2,
            title: "ICSE",
          },
          {
            id: 3,
            title: "ISC",
          },
        ],
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 2,
    placeHolder: "12th",
    options: [
      {
        id: 1,
        placeHolder: "Name of Board",
        options: [
          {
            id: 1,
            title: "CBSE",
          },
          {
            id: 2,
            title: "ICSE",
          },
          {
            id: 3,
            title: "ISC",
          },
        ],
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 3,
    placeHolder: "diploma",
    options: [
      {
        id: 1,
        placeHolder: "Name of Institute",
      },
      {
        id: 2,
        placeHolder: "Qualification Name",
      },
      {
        id: 3,
        placeHolder: "Passing Year",
      },
      {
        id: 4,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 5,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 4,
    placeHolder: "graduation",
    options: [
      {
        id: 1,
        placeHolder: "Qualification Name",
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 5,
    placeHolder: "advanced-diploma",
    options: [
      {
        id: 1,
        placeHolder: "Qualification Name",
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 6,
    placeHolder: "master's",
    options: [
      {
        id: 1,
        placeHolder: "Qualification Name",
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
  {
    id: 7,
    placeHolder: "PhD",
    options: [
      {
        id: 1,
        placeHolder: "Qualification Name",
      },
      {
        id: 2,
        placeHolder: "Passing Year",
      },
      {
        id: 3,
        placeHolder: "Percentage/ CGPA out of....",
        options: [
          {
            id: 1,
            title: "Percentage",
          },
          {
            id: 2,
            title: "CGPA out of 3",
          },
          {
            id: 3,
            title: "CGPA out of 4",
          },
          {
            id: 4,
            title: "CGPA out of 5",
          },
          {
            id: 5,
            title: "CGPA out of 7",
          },
          {
            id: 6,
            title: "CGPA out of 9",
          },
          {
            id: 7,
            title: "CGPA out of 10",
          },
        ],
      },
      {
        id: 4,
        placeHolder: "Score",
      },
    ],
  },
];

export const addAcademicTestOptions = [
  {
    id: 1,
    title: "IELTS",
  },
  {
    id: 2,
    title: "PTE",
  },
  {
    id: 3,
    title: "TOEFL",
  },
];

export const profileTabs = [
  { id: 1, title: "Basic Info", icon: <User /> },
  { id: 2, title: "Education", icon: <BlueEducationCap /> },
  { id: 4, title: "Documents", icon: <UploadDocs /> },
];

export const backgroundInformation = [
  {
    id: 1,
    placeHolder: "Rejected Visa- Yes/No",
    options: [
      {
        id: 1,
        title: "Yes",
      },
      {
        id: 2,
        title: "No",
      },
    ],
  },

  {
    id: 2,
    placeHolder: "Gap (in Years)",
    options: [
      {
        id: 1,
        title: "1 Year",
      },
      {
        id: 2,
        title: "2 Years",
      },
      {
        id: 3,
        title: "3 Years",
      },
      {
        id: 4,
        title: "4 Years",
      },
      {
        id: 5,
        title: "5 Years",
      },
      {
        id: 6,
        title: "6 Years",
      },
      {
        id: 7,
        title: "7 Years",
      },
      {
        id: 8,
        title: "8 Years",
      },
      {
        id: 9,
        title: "9 Years",
      },
      {
        id: 10,
        title: "10 Years",
      },
    ],
  },
  {
    id: 3,
    placeHolder: "If yes, Reason",
  },
];
export const sortOptionsCollege = [
  {
    id: 1,
    title: "Offer letter (longest TAT)",
    key: "offer_tat",
    direction: "desc",
  },
  {
    id: 2,
    title: "Offer letter (shortest TAT)",
    key: "offer_tat",
    direction: "asc",
  },

  {
    id: 3,
    title: "Application Fee (low to high)",
    key: "application_fee",
    direction: "asc",
  },
  {
    id: 4,
    title: "Application Fee (high to low)",
    key: "application_fee",
    direction: "desc",
  },
];

export const UniversitiesSortOptions = [
  {
    id: 1,
    title: "Offer letter (longest TAT)",
    key: "offer_tat",
    direction: "desc",
  },
  {
    id: 2,
    title: "Offer letter (shortest TAT)",
    key: "offer_tat",
    direction: "asc",
  },

  {
    id: 3,
    title: "Application Fee (low to high)",
    key: "application_fees",
    direction: "asc",
  },
  {
    id: 4,
    title: "Application Fee (high to low)",
    key: "application_fees",
    direction: "desc",
  },
];

export const sortOptionsAllCourse = [
  {
    id: 1,
    title: "Duration (shortest first)",
    key: "duration",
    direction: "asc",
  },
  {
    id: 2,
    title: "Duration (longest first)",
    key: "duration",
    direction: "desc",
  },
  {
    id: 3,
    title: "Application Fee (low to high)",
    key: "application_fees",
    direction: "asc",
  },
  {
    id: 4,
    title: "Application Fee (high to low)",
    key: "application_fees",
    direction: "desc",
  },
  {
    id: 5,
    title: "Tuition Fee (low to high)",
    key: "tuition_fee",
    direction: "asc",
  },
  {
    id: 6,
    title: "Tuition Fee (high to low)",
    key: "tuition_fee",
    direction: "desc",
  },
];

export const sortOptionsCourse = [
  {
    id: 1,
    title: "Shortest Duration",
    key: "duration",
    direction: "asc",
  },
  {
    id: 2,
    title: "Longest Duration",
    key: "duration",
    direction: "desc",
  },
  {
    id: 3,
    title: "Fees: Low to high",
    key: "tuition_fee",
    direction: "asc",
  },
  {
    id: 4,
    title: "Fees: High to low",
    key: "tuition_fee",
    direction: "desc",
  },
  {
    id: 5,
    title: "Earliest Start Date",
    key: "start_date",
    direction: "asc",
  },
  {
    id: 6,
    title: "Latest Start Date",
    key: "start_date",
    direction: "desc",
  },
];
export const passportDetails = [
  {
    id: 1,
    placeHolder: "Country of Issue",
    options: [
      {
        id: 1,
        title: "India",
      },
      {
        id: 2,
        title: "UK",
      },
      {
        id: 3,
        title: "USA",
      },
    ],
  },
  {
    id: 2,
    placeHolder: "Passport Number",
  },
  {
    id: 3,
    placeHolder: "Date of Expiry",
  },
];

export const personalDetails = [
  {
    id: 1,
    placeHolder: "Miss/Mrs/ Mr",
    fieldName: "student_metadata.student_title",

    options: [
      {
        id: 1,
        title: "Miss",
      },
      {
        id: 2,
        title: "Mrs",
      },
      {
        id: 3,
        title: "Mr.",
      },
    ],
  },
  {
    id: 2,
    placeHolder: "First Name",
    fieldName: "first_name",
  },
  {
    id: 3,
    placeHolder: "Middle Name",
    fieldName: "middle_name",
  },
  {
    id: 4,
    placeHolder: "Last Name",
    fieldName: "last_name",
  },
  {
    id: 5,
    placeHolder: "Mr./Ms./Dr./Er.",
    options: [
      {
        id: 1,
        title: "Mr.",
      },
      {
        id: 2,
        title: "Ar.",
      },
      {
        id: 3,
        title: "Dr.",
      },
      {
        id: 4,
        title: "Er.",
      },
    ],
  },
  {
    id: 6,
    placeHolder: "Father's Full Name",
    fieldName: "father_name",
  },
  {
    id: 7,
    placeHolder: "Gender",
    fieldName: "gender",
    options: [
      {
        id: 1,
        title: "Female",
      },
      {
        id: 2,
        title: "Male",
      },
      {
        id: 3,
        title: "Other",
      },
    ],
  },
  {
    id: 8,
    placeHolder: "Date of Birth",
    fieldName: "dob",
  },
  {
    id: 9,
    placeHolder: "Marital Status",
    fieldName: "marital_status",
  },
  {
    id: 10,
    placeHolder: "Email",
    fieldName: "email",
  },
  {
    id: 11,
    placeHolder: "Primary Phone Number",
    fieldName: "primary_phone_number",
  },
  {
    id: 12,
    placeHolder: "Secondary Phone Number",
    fieldName: "secondary_phone_number",
  },
];

export const addressDetails = [
  {
    id: 1,
    placeHolder: "Country",
    fieldName: "country",
    options: [
      {
        id: 1,
        title: "India",
      },
      {
        id: 2,
        title: "UK",
      },
      {
        id: 3,
        title: "USA",
      },
      {
        id: 4,
        title: "Canada",
      },
    ],
  },
  {
    id: 2,
    placeHolder: "Pincode*",
  },
  {
    id: 3,
    placeHolder: "State*",
  },
  {
    id: 4,
    placeHolder: "City*",
  },
  {
    id: 5,
    placeHolder: "Address Line 1*",
  },
  {
    id: 6,
    placeHolder: "Address Line 2",
  },
];

export const videoTutorials = [
  {
    image: "/assets/images/png/videoTutorialThumbNail1.png",
    title: "How to Apply for UK Visa- Students ",
    videoUrl: "https://www.youtube.com/embed/g7ksRtgvlxQ?si=fVHX4SQWOmVnWpKU",
  },
  {
    image: "/assets/images/png/videoTutorialThumbNail2.png",
    title: "How to fill the basic Application Form",
    videoUrl: "https://www.youtube.com/embed/g7ksRtgvlxQ?si=fVHX4SQWOmVnWpKU",
  },
  {
    image: "/assets/images/png/videoTutorialThumbNail3.png",
    title: "How to Check your Visa Status",
    videoUrl: "https://www.youtube.com/embed/g7ksRtgvlxQ?si=fVHX4SQWOmVnWpKU",
  },
];

export const englishProficiencyDetails = [
  {
    id: 1,
    title: "IELTS",
    options: [
      {
        id: 1,
        title: "Writing Score",
      },
      {
        id: 2,
        title: "Listening Score",
      },
      {
        id: 3,
        title: "Reading Score",
      },
      {
        id: 4,
        title: "Speaking Score",
      },
      {
        id: 5,
        title: "Overall Score",
      },
    ],
  },
  {
    id: 2,
    title: "PTE",
    options: [
      {
        id: 1,
        title: "Writing Score",
      },
      {
        id: 2,
        title: "Listening Score",
      },
      {
        id: 3,
        title: "Reading Score",
      },
      {
        id: 4,
        title: "Speaking Score",
      },
      {
        id: 5,
        title: "Overall Score",
      },
    ],
  },
  {
    id: 3,
    title: "TOEFL",
    options: [
      {
        id: 1,
        title: "Writing Score",
      },
      {
        id: 2,
        title: "Listening Score",
      },
      {
        id: 3,
        title: "Reading Score",
      },
      {
        id: 4,
        title: "Speaking Score",
      },
      {
        id: 5,
        title: "Overall Score",
      },
    ],
  },
  {
    id: 4,
    title: "Duolingo",
    options: [
      {
        id: 1,
        title: "Writing Score",
      },
      {
        id: 2,
        title: "Listening Score",
      },
      {
        id: 3,
        title: "Reading Score",
      },
      {
        id: 4,
        title: "Speaking Score",
      },
      {
        id: 5,
        title: "Overall Score",
      },
    ],
  },
  {
    id: 5,
    title: "I Don't Have Any",
    options: [
      {
        id: 1,
        title: "Select board",
        options: [
          {
            id: 1,
            title: "CBSE",
          },
          {
            id: 2,
            title: "HBSE",
          },
          {
            id: 3,
            title: "RBSE",
          },
        ],
      },
      {
        id: 2,
        title: "English Marks",
      },
    ],
  },
];
export const studyLevel = [
  { id: 1, name: "Diploma" },
  { id: 2, name: "Bachelor’s" },
  { id: 3, name: "Advanced Diploma" },
  { id: 4, name: "Master’s" },
  { id: 5, name: "PhD" },
];
export const duration = [
  {
    id: 1,
    name: "Less than 1 year",
  },
  {
    id: 2,
    name: "1-2 years",
  },
  {
    id: 3,
    name: "3-4 years",
  },
];

export const destinationsLinks = [
  {
    id: 1,
    name: "United Kingdom",
    url: "#",
    flag: <UKIcon />,
    image: "/assets/images/png/ukCircle.png",
    label: "180+universities",
  },
  {
    id: 2,
    name: "United States",
    url: "#",
    flag: <USAIcon />,
    image: "/assets/images/png/usaCircle.png",
    label: "World class research",
  },
  {
    id: 3,
    name: "Ireland",
    url: "#",
    flag: <IrelandIcon />,
    image: "/assets/images/png/irelandCircle.png",
    label: "Post study work visa",
  },
  {
    id: 4,
    name: "Canada",
    url: "#",
    flag: <CanadaIcon />,
    image: "/assets/images/png/canadaCircle.png",
    label: "PR pathway available",
  },
  {
    id: 5,
    name: "Germany",
    url: "#",
    flag: <GermanyIcons />,
    image: "/assets/images/png/germanyCircle.png",
    label: "Scholarship options",
  },
  {
    id: 6,
    name: "France",
    url: "#",
    flag: <FranceIcon />,
    image: "/assets/images/png/franceCircle.png",
    label: "Affordable living",
  },
  {
    id: 7,
    name: "Europe",
    url: "#",
    flag: <EuropeIcon />,
    image: "/assets/images/png/europeCircle.png",
    label: "Affordable living",
  },
  {
    id: 8,
    name: "Italy",
    url: "#",
    flag: <ItalyIcon />,
    image: "/assets/images/png/italyCircle.png",
    label: "Art & architecture",
  },
  {
    id: 9,
    name: "Netherlands",
    url: "#",
    flag: <NetherLandsIcon />,
    image: "/assets/images/png/netherlandsCircle.png",
    label: "English programs",
  },
  {
    id: 10,
    name: "Spain",
    url: "#",
    flag: <SpainIcon />,
    image: "/assets/images/png/spainCircle.png",
    label: "Low cost of living",
  },
  {
    id: 11,
    name: "New Zealand",
    url: "#",
    flag: <NewZealandIcon />,
    image: "/assets/images/png/newZealandCircle.png",
    label: "Safe & welcoming",
  },
  {
    id: 12,
    name: "Australia",
    url: "#",
    flag: <AustraliaIcon />,
    image: "/assets/images/png/australiaCircle.png",
    label: "150+ universities",
  },
  {
    id: 13,
    name: "Singapore",
    url: "#",
    flag: <SingaporeIcon />,
    image: "/assets/images/png/singapore.png",
    label: "Asia-pacific hub",
  },
  {
    id: 14,
    name: "Malta",
    url: "#",
    flag: <MaltaIcon />,
    image: "/assets/images/png/maltaCircle.png",
    label: "EU English-speaking",
  },
  {
    id: 15,
    name: "Cyprus",
    url: "#",
    flag: <CyprusIcon />,
    image: "/assets/images/png/cyprusCircle.png",
    label: "EU pathway",
  },

  {
    id: 16,
    name: "Hungary",
    url: "#",
    flag: <HungaryIcon />,
    image: "/assets/images/png/hungaryCircle.png",
    label: "Medical programs",
  },
  {
    id: 17,
    name: "Dubai",
    url: "#",
    flag: <DubaiIcon />,
    image: "/assets/images/png/dubaiCircle.png",
    label: "Global business hub",
  },
  {
    id: 18,
    name: "Sweden",
    url: "#",
    flag: <SwedenIcon />,
    image: "/assets/images/png/swedenCircle.png",
    label: "Innovative culture",
  },
  {
    id: 19,
    name: "Malaysia",
    url: "#",
    flag: <MalaysiaIcon />,
    image: "/assets/images/png/malaysiaCircle.png",
    label: "Budget-friendly",
  },
  {
    id: 20,
    name: "South Korea",
    url: "#",
    flag: <SouthKoreaIcon />,
    image: "/assets/images/png/southKorea.png",
    label: "High tech innovation",
  },
  {
    id: 21,
    name: "Finland",
    url: "#",
    flag: <FinlandIcon />,
    image: "/assets/images/png/finlandCircle.png",
    label: "Top ranked education",
  },
  {
    id: 22,
    name: "Estonia",
    url: "#",
    flag: <EstoniaIcon />,
    image: "/assets/images/png/estoniaCircle.png",
    label: "Digital Society",
  },
  {
    id: 23,
    name: "Poland",
    url: "#",
    flag: <PolandIcon />,
    image: "/assets/images/png/poland.png",
    label: "Affordable Education",
  },
  {
    id: 24,
    name: "Latvia",
    url: "#",
    flag: <LatviaIcon />,
    image: "/assets/images/png/latvia.png",
    label: "Digital nation",
  },
  {
    id: 25,
    name: "Greece",
    url: "#",
    flag: <GreeceIcon />,
    image: "/assets/images/png/greeceCircle.png",
    label: "Historic Heritage",
  },
];

export const productsLinks = [
  {
    id: 1,
    name: "Accommodation",
    url: "/products-for-you",
    description: "Find Your Perfect Student Stay",
    icon: <Home />,
  },
  {
    id: 2,
    name: "Education Loan",
    url: "/products-for-you",
    description: "Effortless Education Financing",
    icon: <EducationLoan />,
  },
  {
    id: 3,
    name: "Travel",
    url: "/products-for-you",
    description: "Exclusive Travel Deals for Students",
    icon: <Travel />,
  },
  {
    id: 4,
    name: "Fee Transfer",
    url: "/products-for-you",
    description: "Seamless Transfers for Study Abroad",
    icon: <FeeTransfer />,
  },
];
export const testPreparationLogos = [
  {
    id: 1,
    logo: "/assets/images/png/ielts.png",
    name: "IELTS",
    url: "#",
  },
  {
    id: 2,
    logo: "/assets/images/png/pte.png",
    name: "PTE",
    url: "#",
  },
  {
    id: 3,
    logo: "/assets/images/png/toefl.png",
    name: "PTE",
    url: "#",
  },
  {
    id: 4,
    logo: "/assets/images/png/gmat.png",
    name: "gmat",
    url: "#",
  },
  {
    id: 5,
    logo: "/assets/images/png/gre.png",
    name: "gre",
    url: "#",
  },
  {
    id: 6,
    logo: "/assets/images/png/sat.png",
    name: "sat",
    url: "#",
  },
];
export const ourServicesLinks = [
  {
    id: 1,
    name: "SOP & Interview",
    description: "Standout SOPs. Confident Interviews. Guaranteed Impact.",
    url: "/sop-interview-preparation",
    icon: <Document />,
  },
  {
    id: 2,
    name: "Visa Processing",
    url: "/visa-processing",
    description: "Efficient Visa Processing for Students",
    icon: <VisaProcessing />,
  },
  {
    id: 3,
    name: "Admission Assistance",
    url: "/admission-assistance",
    description: "From dream to degree- start with an offer letter",
    icon: <InterviewPreparation />,
  },
];
export const smallDeviceNavigationLinks = [
  {
    id: 1,
    name: "Study Global",
    url: "/all-countries",
    icon: <Globe />,
  },

  {
    id: 2,
    name: "EdviaBot",
    url: "/chat",
    icon: <WhiteStarts color="black" />,
  },

  {
    id: 3,
    name: "Company",
    url: "",
    icon: <AboutUs />,
    children: [
      {
        id: 1,
        name: "About Us",
        url: "/about-us",
      },
      {
        id: 2,
        name: "For Institutions",
        url: "/for-institutions",
      },
      {
        id: 3,
        name: "News",
        url: "/latest-news",
      },
      {
        id: 4,
        name: "Blogs",
        url: "/blogs",
      },
      {
        id: 4,
        name: "Careers",
        url: "/careers",
      },
    ],
  },

  {
    id: 4,
    name: "Events",
    url: "/events",
    icon: <EducationCap />,
  },
  {
    id: 5,
    name: "Book Exam",
    url: "/book-exam",
    icon: <EducationCap />,
  },
  {
    id: 6,
    name: "Contact Us",
    url: "/contact-us?platform=website",
    icon: <ContactUsIcon />,
  },
];
export const footerSocialLinks = [
  {
    id: 1,
    name: "Facebook",
    url: "https://www.facebook.com/people/Edviaai/61573910458142/?sk=about",
    icon: <Facebook />,
  },
  {
    id: 3,
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/edviaai/posts/?feedView=all&viewAsMember=true",
    icon: <LinkedIn />,
  },
  {
    id: 4,
    name: "YouTube",
    url: "https://www.youtube.com/@Edvia-ai",
    icon: <YouTube />,
  },
  {
    id: 5,
    name: "Instagram",
    url: "https://www.instagram.com/edvia.ai/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#",
    icon: <Instagram />,
  },
  {
    id: 6,
    name: "contact-Us",
    url: "/contact-us?platform=website",
    icon: <ContactIcon />,
  },
];

export const ourStudentSpeaksContent = [
  {
    id: 1,
    title: "Priyanshi, UK",
    description: "“Thankyou, Edvia! Next stop UK”",
    url: "#",
    image: "/assets/images/png/priyanshi.png",
  },
  {
    id: 2,
    title: "Kunal Kapoor, Germany",
    description: "“Officially an international student!”",
    url: "#",
    image: "/assets/images/png/kunal.png",
  },
  {
    id: 3,
    title: "Aanchal, USA",
    description: "“Finally, got the admission in my dream school”",
    url: "#",
    image: "/assets/images/png/aanchal.png",
  },
  {
    id: 4,
    title: "Hardeep, Canada",
    description: "“The seamless journey for student ever been”",
    url: "#",
    image: "/assets/images/png/hardeep.png",
  },
  {
    id: 5,
    title: "Sourabh, UK",
    description: "“Admission process made so easy and transparent”",
    url: "#",
    image: "/assets/images/png/sourabh.png",
  },
  {
    id: 6,
    title: "Mansi katoch, New Zealand",
    description: "“Easy process, great appreciation to Edvia!”",
    url: "#",
    image: "/assets/images/png/rejveer.png",
  },
  {
    id: 7,
    title: "Simran, Germany",
    description: "“Finally my dream coming true, germany here I come”",
    url: "#",
    image: "/assets/images/png/simran.png",
  },
];

export const servicesForYou = [
  {
    id: 1,
    image: "/assets/images/png/sopCreation.png",
    title: "Admission Assistance",
    description: "From dream to degree- start with an offer letter",
    url: "/admission-assistance",
  },
  {
    id: 2,
    image: "/assets/images/png/interviewPreparation.png",
    title: "SOP & Interview Preparation",
    description: "Standout SOPs, Confident interviews, Guaranteed impact.",
    url: "/sop-interview-preparation",
  },
  {
    id: 3,
    image: "/assets/images/png/visaProcessing.png",
    title: "Visa Processing",
    description: "Simplify your visa application with expert guidance",
    url: "/coming-soon",
  },
];

export const studentDashboardLinks = [
  {
    id: 1,
    icon: <LucideHome />,
    title: "Home",
    url: "/dashboard",
  },
  {
    id: 2,
    icon: <Search />,
    title: "Explore",
    url: "/dashboard/search",
  },
  {
    id: 3,
    icon: <FileIcon />,
    title: "Applications",
    url: "/dashboard/applications",
  },
  {
    id: 4,
    icon: <LucideCalendar />,
    title: "Sessions",
    url: "/dashboard/sessions",
  },
  {
    id: 5,
    icon: <Handshake />,
    title: "Services",
    url: "/dashboard/services",
  },
];
export const dashboardChooseCountry = [
  {
    id: 4,
    title: "Australia",
    flag: "/assets/images/png/australiaCircle.png",
    icon: "/assets/images/png/australiaIcon.png",
  },
  {
    id: 2,
    title: "Canada",
    flag: "/assets/images/png/canadaCircle.png",
    icon: "/assets/images/png/canadaIcon.png",
  },
  {
    id: 27,
    title: "Cyprus",
    flag: "/assets/images/png/cyprusCircle.png",
    icon: "/assets/images/png/cyprusIcon.png",
  },
  {
    id: 28,
    title: "France",
    flag: "/assets/images/png/franceCircle.png",
    icon: "/assets/images/png/franceIcon.png",
  },
  {
    id: 29,
    title: "Germany",
    flag: "/assets/images/png/germanyCircle.png",
    icon: "/assets/images/png/germanyIcon.png",
  },
  {
    id: 30,
    title: "Ireland",
    flag: "/assets/images/png/irelandCircle.png",
    icon: "/assets/images/png/irelandIcon.png",
  },
  {
    id: 34,
    title: "Malta",
    flag: "/assets/images/png/maltaCircle.png",
    icon: "/assets/images/png/maltaIcon.png",
  },
  {
    id: 31,
    title: "Netherlands",
    flag: "/assets/images/png/netherlandsCircle.png",
    icon: "/assets/images/png/netherlandsIcon.png",
  },
  {
    id: 32,
    title: "New Zealand",
    flag: "/assets/images/png/newZealandCircle.png",
    icon: "/assets/images/png/newZealandIcon.png",
  },
  {
    id: 3,
    title: "Spain",
    flag: "/assets/images/png/spainCircle.png",
    icon: "/assets/images/png/spainIcon.png",
  },
  {
    id: 3,
    title: "United Kingdom",
    flag: "/assets/images/png/ukCircle.png",
    icon: "/assets/images/png/ukIcon.png",
  },
  {
    id: 1,
    title: "United States",
    flag: "/assets/images/png/usaCircle.png",
    icon: "/assets/images/png/usaIcon.png",
  },
];

export const services = [
  {
    id: 1,
    title: "SOP & Interview Preparation",
    image: "/assets/images/png/sopInterviewPreparation.png",
    url: "sop-interview-preparation",
  },
  {
    id: 2,
    title: "Admission Assistance",
    image: "/assets/images/png/threeBoyInMeeting.png",
    url: "admission-assistance",
  },
  {
    id: 3,
    title: "Visa Processing",
    image: "/assets/images/png/visaPassport.png",
    url: "visa-processing",
  },
];
export const studentTestimonials = [
  {
    id: 1,
    image: "/assets/images/png/simran.png",
    name: "Simran, UK",
    description:
      "The portal made my study abroad journey effortless! From expert advice to tracking applications, everything was seamless",
  },
  {
    id: 2,
    image: "/assets/images/png/rejveer.png",
    name: "Mansi, Canada",
    description:
      "The portal made my study abroad journey effortless! From expert advice to tracking applications, everything was seamless",
  },
  {
    id: 3,
    image: "/assets/images/png/hardeep.png",
    name: "Hardeep, France",
    description:
      "The portal made my study abroad journey effortless! From expert advice to tracking applications, everything was seamless",
  },
  {
    id: 4,
    image: "/assets/images/png/priyanshi.png",
    name: "Priyanshi, Germany",
    description:
      "The portal made my study abroad journey effortless! From expert advice to tracking applications, everything was seamless",
  },
];
export const eventsCards = [
  {
    id: 1,
    image: "/assets/images/png/meeting.png",
    title: "Test Preparation-Workshop",
    description:
      "How to prepare for different english tests- IELTS, TOEFL, PTE and more",
    date: "30th-2nd November, 2024",
    time: "8pm-10pm - Online",
  },
  {
    id: 2,
    image: "/assets/images/png/meeting.png",
    title: "Test Preparation-Workshop",
    description:
      "How to prepare for different english tests- IELTS, TOEFL, PTE and more",
    date: "30th-2nd November, 2024",
    time: "8pm-10pm - Online",
  },
  {
    id: 3,
    image: "/assets/images/png/meeting.png",
    title: "Test Preparation-Workshop",
    description:
      "How to prepare for different english tests- IELTS, TOEFL, PTE and more",
    date: "30th-2nd November, 2024",
    time: "8pm-10pm - Online",
  },
  {
    id: 4,
    image: "/assets/images/png/meeting.png",
    title: "Test Preparation-Workshop",
    description:
      "How to prepare for different english tests- IELTS, TOEFL, PTE and more",
    date: "30th-2nd November, 2024",
    time: "8pm-10pm - Online",
  },
];

export const resources = [
  {
    id: 1,
    image: "/assets/images/png/scholarshipInformation.png",
    title: "Scholarship Information >",
    url: "/scholarship-information",
  },
  {
    id: 2,
    image: "/assets/images/png/studyAbroadGuides.png",
    title: "Study Abroad Guides >",
    url: "/study-abroad-guides",
  },
];

export const scholarshipDetails = [
  {
    id: 1,
    title: "British Council Scholarships",
    description:
      "A variety of funding opportunities for students from select countries, including the UK.",
  },
  {
    id: 2,
    title: "Commonwealth Scholarships",
    description:
      "Designed for students from low- and middle-income Commonwealth countries",
  },
  {
    id: 3,
    title: "University- Specific grants",
    description:
      "Many UK universities offer their own scholarships or financial aid programs for international students.",
  },
  {
    id: 4,
    title: "Chevening Scholarships",
    description:
      "Fully funded scholarships provided by the UK government for outstanding individuals with leadership potential.",
  },
  {
    id: 5,
    title: "Chevening Scholarships",
    description:
      "Fully funded scholarships provided by the UK government for outstanding individuals with leadership potential.",
  },
];

export const PopularFields = [
  {
    icon: <Briefcase />,
    title: "business-management",
  },
  {
    icon: <WrenchMen />,
    title: "engineering-technology",
  },
  {
    icon: <Heart />,
    title: "medicine-healthcare",
  },
  {
    icon: <Computer />,
    title: "computer-science",
  },
  {
    icon: <Gavel />,
    title: "law",
  },
  {
    icon: <Theater />,
    title: "arts-humanities",
  },
  {
    icon: <Users />,
    title: "social-sciences",
  },
  {
    icon: <Leaf />,
    title: "natural-sciences",
  },
  {
    icon: <GraduationCap />,
    title: "education",
  },
  {
    icon: <Building />,
    title: "hospitality-tourism",
  },
  {
    icon: <Theater />,
    title: "creative-arts",
  },
  {
    icon: <EconomicsIcon />,
    title: "economics",
  },
  {
    icon: <EnglishIcon />,
    title: "english",
  },
];

export const streamsList = [
  { id: 1, title: "Agriculture" },
  { id: 2, title: "Arts and Humanities" },
  { id: 3, title: "Business and Management" },
  { id: 4, title: "Economics" },
  { id: 5, title: "Finance" },
  { id: 6, title: "Engineering" },
  { id: 7, title: "Hospitality and Tourism" },
  { id: 8, title: "Information Technology" },
  { id: 9, title: "Law" },
  { id: 10, title: "Medical and Healthcare" },
  { id: 11, title: "Natural Sciences" },
  { id: 12, title: "Social Science" },
  { id: 13, title: "Theoritical and Fundamental Sciences" },
];

export const specialisations = [
  { id: 1, title: "Accounting and Finance" },
  { id: 2, title: "Acting" },
  { id: 3, title: "Adult Nursing" },
  { id: 4, title: "Advertising and Marketing Communications" },
  { id: 5, title: "Aeronautical Engineering" },
  { id: 6, title: "Animation" },
  { id: 7, title: "Applied Computing" },
  { id: 8, title: "Architecture" },
  { id: 9, title: "Biomedical Science" },
  { id: 10, title: "Computer Games Programming" },
  { id: 11, title: "Computer Science" },
  { id: 12, title: "Concept and Comic Arts" },
  { id: 13, title: "Contour Fashion" },
  { id: 14, title: "Creative Writing and Drama" },
  { id: 15, title: "Architectural Technology" },
  { id: 16, title: "Automotive Engineering" },
  { id: 17, title: "Business Finance" },
  { id: 18, title: "Business Information Technology" },
  { id: 19, title: "Business Management" },
  { id: 20, title: "Business with Marketing" },
  { id: 21, title: "Civil Engineering" },
  { id: 22, title: "Computer Networks and Security" },
  { id: 23, title: "Computer Science with Artificial Intelligence" },
  { id: 24, title: "Computing and Information Technology" },
  { id: 25, title: "Construction Management" },
  { id: 26, title: "Criminology" },
  { id: 27, title: "Archaeology" },
  { id: 28, title: "Biomedical Engineering" },
  { id: 29, title: "Business and Management" },
  { id: 30, title: "Business Studies and Law" },
  { id: 31, title: "Chemical Engineering" },
  { id: 32, title: "Civil and Structural Engineering" },
  { id: 33, title: "Clinical Sciences" },
  { id: 34, title: "Clinical Technology" },
  { id: 35, title: "Science with Foundation" },
  { id: 36, title: "Music Technology" },
  { id: 37, title: "Architectural Assistant Degree" },
  { id: 38, title: "Accounting with Finance" },
  { id: 39, title: "Biochemistry" },
  { id: 40, title: "Biology" },
  { id: 41, title: "Building Surveying" },
  { id: 42, title: "Business and Human Resource Management" },
  { id: 43, title: "Business and Supply Chain Management" },
  {
    id: 44,
    title:
      "Chartered Manager Degree Apprenticeship (Business Leadership and Management)",
  },
  {
    id: 45,
    title: "Chartered Surveyor Degree Apprenticeship (Building Surveying)",
  },
  { id: 46, title: "Childhood and Youth Studies" },
  { id: 47, title: "Childhood and Youth Studies with Criminology" },
  { id: 48, title: "Childhood and Youth Studies with Psychology" },
  { id: 49, title: "Civil Engineer Degree Apprenticeship (Civil Engineering)" },
  { id: 50, title: "Computer Animation and Visual Effects" },
  { id: 51, title: "Computer Games Art" },
  { id: 52, title: "Computer Games Design" },
  { id: 53, title: "Computer Games Production" },
  { id: 54, title: "Computer Games Technology" },
  { id: 55, title: "Computing" },
  {
    id: 56,
    title: "Counter Terrorism, Intelligence and Cybercrime(Dual Degree)",
  },
  { id: 57, title: "Creative Computing" },
  { id: 58, title: "Creative Media Technologies" },
  { id: 59, title: "Creative Music Technology" },
  { id: 60, title: "Creative Writing" },
  { id: 61, title: "Criminology and Criminal Justice (Distance Learning)" },
  { id: 62, title: "Criminology and Cybercrime" },
  { id: 63, title: "Criminology and Forensic Investigation" },
  { id: 64, title: "Criminology and Psychology" },
  { id: 65, title: "Cyber Security and Forensic Computing" },
  { id: 66, title: "Data Science and Analytics" },
  { id: 67, title: "Digital Marketing" },
  { id: 68, title: "Early Childhood Studies" },
  { id: 69, title: "Early Childhood Studies with Psychology" },
  { id: 70, title: "Earth Science" },
  { id: 71, title: "Economics" },
  { id: 72, title: "Economics and Management" },
  { id: 73, title: "Economics, Finance and Banking" },
  { id: 74, title: "Electrical Power Engineering" },
  { id: 75, title: "Electronic Engineering" },
  { id: 76, title: "Engineering and Technology with Foundation Year" },
  { id: 77, title: "English and Creative Writing" },
  { id: 78, title: "English and History" },
  { id: 79, title: "English Language and Linguistics" },
  { id: 80, title: "English Language and Linguistics with Literature" },
  { id: 81, title: "English Literature" },
  { id: 82, title: "English Literature with History" },
  { id: 83, title: "English Literature with Media Studies" },
  { id: 84, title: "Entrepreneurship and Business" },
  { id: 85, title: "Environmental Science" },
  { id: 86, title: "Interior Architecture and Design" },
  { id: 87, title: "International Business" },
  { id: 88, title: "International Business and Languages" },
  { id: 89, title: "International Development" },
  { id: 90, title: "International Development and Languages" },
  { id: 91, title: "International Development with Sociology" },
  { id: 92, title: "International Relations" },
  { id: 93, title: "International Relations and Languages" },
  { id: 94, title: "International Relations and Politics" },
  { id: 95, title: "International Relations with History" },
  { id: 96, title: "International Relations with International Development" },
  { id: 97, title: "Journalism" },
  { id: 98, title: "Journalism with Creative Writing" },
  { id: 99, title: "Journalism with Media Studies" },
  { id: 100, title: "Language Studies" },
  { id: 101, title: "Law" },
  { id: 102, title: "Law with Business" },
  { id: 103, title: "Law with Criminology" },
  { id: 104, title: "Law with Legal Practice" },
  { id: 105, title: "Marine Biology" },
  { id: 106, title: "Marine Environmental Science" },
  { id: 107, title: "Marketing" },
  { id: 108, title: "Marketing and Management" },
  { id: 109, title: "Mathematics" },
  { id: 110, title: "Mathematics for Finance and Management" },
  { id: 111, title: "Mathematics with Machine Learning" },
  { id: 112, title: "Mathematics with Statistics" },
  { id: 113, title: "Mechanical and Manufacturing Engineering" },
  { id: 114, title: "Mechanical Engineering" },
  { id: 115, title: "Media and Communication with Foundation" },
  { id: 116, title: "Media Studies" },
  { id: 117, title: "Modern Languages" },
  { id: 118, title: "Musical Theatre" },
  { id: 119, title: "Palaeontology" },
  { id: 120, title: "Pharmacology" },
  { id: 121, title: "Community Studies" },
  { id: 122, title: "Centre for Entertainment Arts" },
  { id: 123, title: "Medical" },
  { id: 124, title: "Commerce" },
  { id: 125, title: "Hospitality" },
  { id: 126, title: "Agricultural Sciences" },
  { id: 127, title: "Environmental Management" },
  { id: 128, title: "Human Services" },
  { id: 129, title: "Fine & Applied Arts" },
  { id: 130, title: "Business & Professional Studies" },
  { id: 131, title: "Education, Health & Human Development" },
  { id: 132, title: "Arts & Sciences" },
  { id: 133, title: "Film, Television and Video Production" },
  { id: 134, title: "Bachelor of Arts in International Relations" },
  { id: 135, title: "Counselling" },
  { id: 136, title: "Architectural Studies" },
  { id: 137, title: "Construction Engineering" },
  { id: 138, title: "Construction Management and Technology" },
  { id: 139, title: "Environmental Design" },
  { id: 140, title: "Industrial Design" },
  { id: 141, title: "Interior Design" },
  { id: 142, title: "Landscape Architecture" },
  { id: 143, title: "Urban Planning" },
  { id: 144, title: "Architecture (Energy Perf/Climate Responsive Arch)" },
  { id: 145, title: "Aeronautics" },
  { id: 146, title: "Aerospace Engineering" },
  { id: 147, title: "African American Studies" },
  { id: 148, title: "American Studies" },
  { id: 149, title: "Analytics" },
  { id: 150, title: "Anthropology" },
  { id: 151, title: "Art History" },
  { id: 152, title: "Artificial Intelligence" },
  { id: 153, title: "Biostatistics" },
  { id: 154, title: "Business Technology Management" },
  { id: 155, title: "Chemistry" },
  { id: 156, title: "Advanced Security Management" },
  { id: 157, title: "Digital Forensics" },
  { id: 158, title: "Financial Services" },
  { id: 159, title: "History" },
  { id: 160, title: "Information Science" },
  { id: 161, title: "International Business Management" },
  { id: 162, title: "Political Science" },
  { id: 163, title: "Real Estate" },
  { id: 164, title: "Social Work" },
  { id: 165, title: "Sociology" },
];

export const additionalSubject = [
  { id: "0", title: "Entrepreneurship" },
  { id: "1", title: "Physical Education" },
  { id: "2", title: "Hindustani Music MEL INS" },
  { id: "3", title: "Hindustani Music PER INS" },
  { id: "4", title: "Multi-Media" },
  { id: "5", title: "Automotive" },
  { id: "6", title: "Health Care" },
  { id: "7", title: "Data Science" },
  { id: "8", title: "Electronics & Hardware" },
  { id: "9", title: "Food Production" },
  { id: "10", title: "Office Procedures & Practices" },
  { id: "11", title: "Design" },
  { id: "12", title: "Early Childhood Care & Education" },
  { id: "13", title: "Typography & Computer Application" },
  { id: "14", title: "Physics" },
  { id: "15", title: "Business Studies" },
  { id: "16", title: "Business Administration" },
  { id: "17", title: "Geography" },
  { id: "18", title: "French" },
  { id: "19", title: "Taxation" },
  { id: "20", title: "Textile Design" },
  { id: "21", title: "Artificial Intelligence" },
  { id: "22", title: "Chemistry" },
  { id: "23", title: "Financial Markets Management" },
  { id: "24", title: "Beauty & Welness" },
  { id: "25", title: "Medical Diagnostics" },
  { id: "26", title: "Engineering Graphics" },
  { id: "27", title: "Bharatnatyam- Dance" },
  { id: "28", title: "Kuchipudi- Dance" },
  { id: "29", title: "Odissi- Dance" },
  { id: "30", title: "Manipuri- Dance" },
  { id: "31", title: "Kathakali- Dance" },
  { id: "32", title: "Horticulture" },
  { id: "33", title: "Cost Accounting" },
  { id: "34", title: "Library & Information Science" },
  { id: "35", title: "Legal Studies" },
  { id: "36", title: "Retail" },
  { id: "37", title: "National Cadet Corps (NCC)" },
  { id: "38", title: "Banking" },
  { id: "39", title: "Agriculture" },
  { id: "40", title: "Marketing" },
  { id: "41", title: "Fashion Studies" },
  { id: "42", title: "Mass Media Studies" },
  { id: "43", title: "Design Thinking And Innovation" },
  { id: "44", title: "Mathematics" },
  { id: "45", title: "Applied Mathematics" },
  { id: "46", title: "Tourism" },
  { id: "47", title: "Air-Conditioning & Refrigeration" },
  { id: "48", title: "Salesmanship" },
  { id: "49", title: "English Elective" },
  { id: "50", title: "English Core" },
  { id: "51", title: "Yoga" },
  { id: "52", title: "Physical Activity Trainer" },
  { id: "53", title: "Web Application" },
  { id: "54", title: "Hindi Elective" },
  { id: "55", title: "Hindi Core" },
  { id: "56", title: "Urdu Elective" },
  { id: "57", title: "Sanskrit Elective" },
  { id: "58", title: "Carnatic Music Vocal" },
  { id: "59", title: "Carnatic Music MEL INS" },
  { id: "60", title: "Carnatic Music PER INS Mridangam" },
  { id: "61", title: "Kathak- Dance" },
  { id: "62", title: "Urdu Core" },
  { id: "63", title: "Front Office Operations" },
  { id: "64", title: "Insurance" },
  { id: "65", title: "Geospatial Technology" },
  { id: "66", title: "Electrical Technology" },
  { id: "67", title: "Painting" },
  { id: "68", title: "Graphics" },
  { id: "69", title: "Sculpture" },
  { id: "70", title: "Applied Art (Commercial Art)" },
  { id: "71", title: "Economics" },
  { id: "72", title: "Hindustani Music Vocal" },
  { id: "73", title: "Biotechnology" },
  { id: "74", title: "Knowledge Tradition & Practices Of India" },
  { id: "75", title: "Bhoti" },
  { id: "76", title: "Kokborok" },
  { id: "77", title: "Electronic Technology" },
  { id: "78", title: "Shorthand (English)" },
  { id: "79", title: "Shorthand (Hindi)" },
  { id: "80", title: "Food Nutrition & Dietetics" },
  { id: "81", title: "Political Science" },
  { id: "82", title: "Sanskrit Core" },
  { id: "83", title: "Biology" },
  { id: "84", title: "Accountancy" },
  { id: "85", title: "Sociology" },
  { id: "86", title: "Informatics Practices" },
  { id: "87", title: "Computer Science" },
  { id: "88", title: "Information Technology" },
  { id: "89", title: "History" },
  { id: "90", title: "Punjabi" },
  { id: "91", title: "Bengali" },
  { id: "92", title: "Tamil" },
  { id: "93", title: "Telugu" },
  { id: "94", title: "Sindhi" },
  { id: "95", title: "Marathi" },
  { id: "96", title: "Gujrati" },
  { id: "97", title: "Manipuri" },
  { id: "98", title: "Malayalam" },
  { id: "99", title: "Odia" },
  { id: "100", title: "Assamese" },
  { id: "101", title: "Kannada" },
  { id: "102", title: "Arabic" },
  { id: "103", title: "Tibetan" },
  { id: "104", title: "German" },
  { id: "105", title: "Russian" },
  { id: "106", title: "Persian" },
  { id: "107", title: "Nepali" },
  { id: "108", title: "Limboo" },
  { id: "109", title: "Lepcha" },
  { id: "110", title: "Telugu Telangana" },
  { id: "111", title: "Bodo" },
  { id: "112", title: "Tangkhul" },
  { id: "113", title: "Japanese" },
  { id: "114", title: "Bhutia" },
  { id: "115", title: "Spanish" },
  { id: "116", title: "Kashmiri" },
  { id: "117", title: "Mizo" },
  { id: "118", title: "Home Science" },
  { id: "119", title: "Psychology" },
];

export const customCountryList = [
  {
    country_id: 4,
    country_name: "australia",
    priority_ranking: 4,
    country_currency: "AUD",
    university_count: "36",
  },
  {
    country_id: 2,
    country_name: "canada",
    priority_ranking: 3,
    country_currency: "CAD",
    university_count: "98",
  },
  {
    country_id: 6,
    country_name: "europe - cyprus",
    priority_ranking: 8,
    country_currency: "EUR",
    university_count: "5",
  },
  {
    country_id: 7,
    country_name: "europe - france",
    priority_ranking: 10,
    country_currency: "EUR",
    university_count: "3",
  },
  {
    country_id: 8,
    country_name: "europe - germany",
    priority_ranking: 6,
    country_currency: "EUR",
    university_count: "25",
  },
  {
    country_id: 9,
    country_name: "europe - ireland",
    priority_ranking: 7,
    country_currency: "EUR",
    university_count: "8",
  },
  {
    country_id: 13,
    country_name: "europe - malta",
    priority_ranking: 11,
    country_currency: "EUR",
    university_count: "4",
  },
  {
    country_id: 10,
    country_name: "europe - netherlands",
    priority_ranking: 9,
    country_currency: "EUR",
    university_count: "6",
  },
  {
    country_id: 12,
    country_name: "europe - spain",
    priority_ranking: 12,
    country_currency: "EUR",
    university_count: "1",
  },
  {
    country_id: 11,
    country_name: "new zealand",
    priority_ranking: 5,
    country_currency: "NZD",
    university_count: "6",
  },
  {
    country_id: 14,
    country_name: "singapore",
    priority_ranking: 13,
    country_currency: "SGD",
    university_count: "1",
  },
  {
    country_id: 3,
    country_name: "united kingdom",
    priority_ranking: 1,
    country_currency: "GBP",
    university_count: "56",
  },
  {
    country_id: 1,
    country_name: "united states",
    priority_ranking: 2,
    country_currency: "USD",
    university_count: "23",
  },
];

export const visaGuidesContent = [
  {
    id: 1,
    title: "United Kingdom",
    image: "/assets/images/png/visaGuides/uk.png",
    status: "open",
  },
  {
    id: 2,
    title: "United States of America",
    image: "/assets/images/png/visaGuides/usa.png",
    status: "close",
  },
  {
    id: 3,
    title: "Australia",
    image: "/assets/images/png/visaGuides/Australia.png",
    status: "close",
  },
];

export const ukVisaProcessing = [
  {
    id: 1,
    title: "On Google search, enter UK Study Visa",
    image: "/assets/images/png/visaGuides/ukStep1.png",
  },
  {
    id: 2,
    title: (
      <>
        Click on the first link{" "}
        <a
          href="https://www.gov.uk/student-visa"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-blue-600 duration-300"
        >
          https://www.gov.uk/student-visa
        </a>
      </>
    ),
    image: "/assets/images/png/visaGuides/ukStep2.png",
  },
  {
    id: 3,
    title: "Click On Apply Online",
    image: "/assets/images/png/visaGuides/ukStep3.png",
  },
  {
    id: 4,
    title: "Then click on Start Now",
    image: "/assets/images/png/visaGuides/ukStep4.png",
  },
  {
    id: 5,
    title:
      "Select the option that applies to you, we are selecting options as per the profile of an Indian Student who is going to study at De Montfort University in England.",
    image: "/assets/images/png/visaGuides/ukStep5.png",
  },
];

export const Products = [
  {
    id: 1,
    title: "Test Preparation",
    image: "/assets/images/png/product/test.png",
  },
  {
    id: 2,
    title: "Student Loan",
    image: "/assets/images/png/product/student.png",
  },
  {
    id: 3,
    title: "Fees Transfer",
    image: "/assets/images/png/product/fees.png",
  },
  {
    id: 4,
    title: "Flights & Accommodation",
    image: "/assets/images/png/product/flights.png",
  },
];

export const constructorUniversitySpecialization = [
  {
    id: 1,
    title: "Offer Response",
    icon: <WhiteClockIcon />,
  },
  {
    id: 2,
    title: "Application Fees",
    icon: <Fee color="white" />,
  },
  {
    id: 3,
    title: "Backlogs Accepted",
    icon: <BackLogsDocIcon />,
  },
  {
    id: 4,
    title: "Post Study Work Permit",
    icon: <WorkPermitBag />,
  },
];

export const searchSuggestions = [
  {
    id: 1,
    title: "Msc. in Canada",
  },
  {
    id: 2,
    title: "I want to study Data Science",
  },
  {
    id: 3,
    title: "Study MBA in USA",
  },
  {
    id: 4,
    title: "Courses in Germany",
  },
  {
    id: 5,
    title: "Masters in Artificial Intelligence",
  },
  {
    id: 6,
    title: "Bachelor’s in Australia",
  },
];

export const educationJourney = [
  {
    id: 1,
    title: "Check Eligibility",
    icon: "/assets/images/png/homepage/check-eligibility.png",
    url: "/ai-course-finder/eligibility?query=pick-country",
  },
  {
    id: 2,
    title: "Search Institutes",
    icon: "/assets/images/png/homepage/search-institutes.png",
    url: "/ai-course-finder/institutes?query=pick-country",
  },
  {
    id: 3,
    title: "Search Programs",
    icon: "/assets/images/png/homepage/search-programs.png",
    url: "/ai-course-finder/program?query=pick-country",
  },
  {
    id: 4,
    title: "Find Scholarships",
    icon: "/assets/images/png/homepage/find-scholarships.png",
    url: "find-scholarships",
  },
  {
    id: 5,
    title: "Talk to an Expert",
    icon: "/assets/images/png/homepage/talk-to-expert.png",
    url: "",
  },
  {
    id: 6,
    title: "Visa Assistance",
    icon: "/assets/images/png/homepage/visa-assistance.png",
    url: "/visa-processing",
  },
];

export const achievementsMilestones = [
  {
    id: 1,
    image: "/assets/images/png/home/abp.png",
    url: "https://news.abplive.com/brand-wire/edvia-uses-ai-to-help-students-find-the-best-courses-and-universities-abroad-1811663",
  },
  {
    id: 2,
    image: "/assets/images/png/home/news18.png",
    url: "https://www.news18.com/agency-feeds/edvia-explore-the-worlds-top-universities-effortlessly-9707757.html",
  },
  {
    id: 3,
    image: "/assets/images/png/home/pti.png",
    url: "https://www.ptinews.com/press-release/edvia-powered-by-ai-designed-for-students/3097126",
  },
  {
    id: 4,
    image: "/assets/images/png/home/theWeek.png",
    url: "https://www.theweek.in/wire-updates/business/2025/11/15/dcm19-edvia.html",
  },
  {
    id: 5,
    image: "/assets/images/png/home/theTribune.png",
    url: "https://www.tribuneindia.com/news/business/edvia-explore-the-worlds-top-universities-effortlessly/#:~:text=Edvia.ai%20offers%20smart%20AI,AI%20power%20your%20global%20dreams.",
  },
];

export const countryMetaData = [
  {
    id: 1,
    name: "australia",
    title: "Study in Australia for Indian Students",
    description:
      "Get a complete guide to studying in Australia for Indian students, including top universities, courses and support to make your dream come true.",
  },
  {
    id: 2,
    name: "canada",
    title: "Study in Canada | Complete Guide for Indian Students",
    description:
      "Study in Canada with confidence. This complete guide for Indian students covers top universities, courses expert support for a smooth journey.",
  },
  {
    id: 3,
    name: "new-zealand",
    title: "Study in New Zealand for Indian Students – Complete Guide",
    description:
      "Plan your study in New Zealand with this complete guide for Indian students. Get details on top universities, courses and expert support for success.",
  },
  {
    id: 4,
    name: "united-kingdom",
    title: "Study in the UK - Indian Student Information Portal",
    description:
      "Find everything Indian students need to study in the UK—universities, courses, scholarships, and expert tips to begin your UK education journey.",
  },
  {
    id: 5,
    name: "singapore",
    title: "Singapore Study Guide for Indian Students Made Easy",
    description:
      "Your simple guide to studying in Singapore for Indian students. Learn about top universities, courses, visa processes, scholarships, and expert advice.",
  },
  {
    id: 6,
    name: "united-states",
    title: "USA Universities & Courses Guide for Indian Students",
    description:
      "Find top USA universities & courses for Indian students with detailed info on admissions, scholarships, programs, and expert tips for a successful journey.",
  },
  {
    id: 7,
    name: "cyprus",
    title: "Study in Cyprus for Indian Students-Cost and Visa",
    description:
      "Study in Cyprus for Indian students with a complete guide on tuition fees, living costs, and many more requirements for your smooth study abroad journey.",
  },
  {
    id: 8,
    name: "france",
    title: "Complete study in France guide for Indian students - Edvia",
    description:
      "Edvia’s complete guide helps Indian students study in France with info on universities, courses, admissions, visas, and essential living tips.",
  },
  {
    id: 9,
    name: "germany",
    title: "Study in Germany complete guide for Indian students",
    description:
      "Complete guide for Indian students on studying in Germany, covering universities, courses, visa tips, scholarships, and helpful advice for a smooth journey.",
  },
  {
    id: 10,
    name: "ireland",
    title: "Complete study in Ireland guide for Indian students",
    description:
      "Planning to study in Ireland? This complete guide for Indian students covers top universities, courses, visa details, scholarships & expert tips to succeed.",
  },
  {
    id: 11,
    name: "malta",
    title: "Study in Malta for Indian Student - Universities and Courses",
    description:
      "Study in Malta for Indian students with details on top universities, courses, visa process, scholarships, and expert tips to help you plan your journey.",
  },
  {
    id: 12,
    name: "netherlands",
    title: "Indian students guide to study in Netherlands easily",
    description:
      "Indian students can easily study in the Netherlands with this guide covering top universities,courses, scholarships, and helpful tips for success.",
  },
  {
    id: 13,
    name: "spain",
    title: "Spain universities' courses guide for Indian students",
    description:
      "Top guide for Indian students to study in Spain. Learn about best universities, courses, admission tips, visa requirements, scholarships, and expert advice.",
  },
];

export const universitiesMetaData = [
  {
    id: 1,
    name: "australia",
    title: "Top Universities in Australia for India Students.",
    description:
      "Leading Australian universities for Indian students with details on admissions, eligibility, tuition fees, scholarships, accommodation, and visa process.",
  },
  {
    id: 2,
    name: "canada",
    title: "Top Universities in Canada for Indian Students",
    description:
      "Best Canadian universities for Indian students offering quality education, affordable tuition, popular courses, visa support, and strong career prospects.",
  },
  {
    id: 3,
    name: "new-zealand",
    title: "List of Universities in New Zealand for Indian Students",
    description:
      "Top universities in New Zealand for Indian students offering quality courses, affordable fees, scholarships, easy admissions, visa help, and student support.",
  },
  {
    id: 4,
    name: "united-kingdom",
    title: "Top List of Universities & Colleges in UK - Courses, Fees",
    description:
      "A detailed list of UK universities and colleges with courses, fees, scholarships, admission criteria,& student support for those planning to study abroad.",
  },
  {
    id: 5,
    name: "singapore",
    title: "Top Universities in Singapore for Indian Students",
    description:
      "Best universities in Singapore for Indian students with details on courses, fees, scholarships, admission criteria, visa guidance, and campus facilities.",
  },
  {
    id: 6,
    name: "united-states",
    title: "Top Universities in USA for Indian Students - Edvia. Ai",
    description:
      "Find top USA universities for Indian students with Edvia.AI. Get key info on admissions, tuition fees, scholarships, visa support, and career opportunities.",
  },
  {
    id: 7,
    name: "cyprus",
    title: "Study in Cyprus | Eligibility | Requirements - Edvia. Ai",
    description:
      "Explore Edvia.ai's comprehensive guide on studying in Cyprus. Learn about eligibility criteria, student visa requirements, top universities, and available scholarships.",
  },
  {
    id: 8,
    name: "france",
    title: "Top Universities in France for Indian Students - Edvia. Ai",
    description:
      "Learn about top French universities for Indian students. Understand eligibility, admission requirements, and available scholarships for studying in France",
  },
  {
    id: 9,
    name: "germany",
    title: "Public Universities in Germany for Indian Students",
    description:
      "Study at top public universities in Germany, offering quality education without tuition fees. Learn about admission requirements, scholarships & living costs.",
  },
  {
    id: 10,
    name: "ireland",
    title: "Best Universities and Colleges in Ireland",
    description:
      "Discover Ireland's top universities &  colleges. Learn about admission requirements, scholarships, & programs to plan your higher education journey in Ireland.",
  },
  {
    id: 11,
    name: "malta",
    title: "Complete Guide to University of Malta and Coursess",
    description:
      "Comprehensive guide to the University of Malta – includes courses, admission requirements, academic programs, & essential information for prospective students.",
  },
  {
    id: 12,
    name: "netherlands",
    title: "Top Universities in the Netherlands for Indian Students",
    description:
      "Find the top universities in the Netherlands for Indian students, with course options, admission process, tuition fees, scholarships, and living details.",
  },
  {
    id: 13,
    name: "spain",
    title: "Study in Spain for Indian Students – Courses & Fees",
    description:
      "Guide to studying in Spain for Indian students – learn about popular courses, tuition fees, universities, visa process, and student life in Spain.",
  },
];

export const financialRequirements = [
  {
    id: 21,
    country: "italy",
    fundValid: "04-06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 15,
    country: "south-korea",
    fundValid: "04-06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 20,
    country: "estonia",
    fundValid: "04-06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 19,
    country: "finland",
    fundValid: "06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 1,
    country: "united-kingdom",
    fundValid: " 28 days",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 2,
    country: "united-states",
    fundValid: " 01 days",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 3,
    country: "australia",
    fundValid: " 03 - 06 months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Property Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 4,
    country: "new-zealand",
    fundValid: " 03 - 06 months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Property Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 5,
    country: "cyprus",
    fundValid: " 01 days",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 6,
    country: "germany",
    fundValid: " 01 days",
    features: [
      {
        id: "block_account_fund",
        title: "Block Account",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Blocked Account </span>
                Confirmation from a recognized German bank (e.g., Fintiba,
                Expatrio, Deutsche Bank)
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 7,
    country: "spain",
    fundValid: " 03 - 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 8,
    country: "canada",
    fundValid: " 01 Day ",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",

        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",

        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 3,
            title: "Affidavit",
          },
          {
            id: 4,
            title: `Notarized Person’s Visiting Card`,
          },
          {
            id: 5,
            title: `Birth Certificate`,
          },
        ],
      },
      {
        id: "gic_account",
        title: "GIC",
        label: "Account",

        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",

        details: [
          {
            id: 1,
            title: `GIC Certificate`,
          },
          {
            id: 2,
            title: `Payment Receipt`,
          },
          {
            id: 3,
            title: `Investment Account Statement (If applicable)`,
          },
          {
            id: 4,
            title: `Letter of Acknowledgement`,
          },
        ],
      },
    ],
  },

  {
    id: 9,
    country: "malta",
    fundValid: " 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 10,
    country: "france",
    fundValid: " 04 - 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 11,
    country: "netherlands",
    fundValid: " 03 - 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 12,
    country: "netherlands",
    fundValid: " 04 - 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 13,
    country: "ireland",
    fundValid: " 04 - 06 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },
    ],
  },

  {
    id: 17,
    country: "hungary",
    fundValid: "6 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },

          { id: 2, title: "Affidavit" },
          { id: 3, title: "Notarized Person’s Visiting Card" },
        ],
      },
      {
        id: "spouse_fund",
        title: "Spouse",
        label: "Funds",

        icon: <Spouse />,
        lightColor: "bg-[#FBCCE5]",
        bgColor: "bg-[#FDF2F8]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FB64B6_0%,#F6339A_50%,_#E60076_100%)]",

        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },

          {
            id: 2,
            title: `Marriage Certificate`,
          },
        ],
      },
      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },

          { id: 2, title: "Affidavit" },
          { id: 3, title: "Notarized Person’s Visiting Card" },
          { id: 4, title: "Birth Certificate" },
        ],
      },
    ],
  },

  {
    id: 18,
    country: "sweden",
    fundValid: "3 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "guardian_fund",
        title: "Guardian",
        label: "Funds",
        icon: <Guardain />,
        lightColor: "bg-[#FFDBBE]",
        bgColor: "bg-[#FFF7ED]",
        gridentColor:
          "bg-[linear-gradient(90deg,#FF8904_0%,#FF6900_50%,_#F54900_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },

          { id: 2, title: "Affidavit" },
          { id: 3, title: "Notarized Person’s Visiting Card" },
        ],
      },

      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },

          { id: 2, title: "Affidavit" },
          { id: 3, title: "Notarized Person’s Visiting Card" },
          { id: 4, title: "Birth Certificate" },
        ],
      },
    ],
  },
  {
    id: 19,
    country: "dubai",
    fundValid: "3 Months",
    features: [
      {
        id: "personal_fund",
        title: "Personal",
        label: "Funds",
        icon: <Personal />,
        lightColor: "bg-[#C8DEFF]",
        bgColor: "bg-[#EFF6FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#51A2FF_0%,#2B7FFF_50%,_#155DFC_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate
              </>
            ),
          },
        ],
      },
      {
        id: "personal_loan",
        title: "Personal",
        label: "Loan",
        icon: <PersonalGreen />,
        lightColor: "bg-[#C0F2D3]",
        bgColor: "bg-[#F0FDF4]",
        gridentColor:
          "bg-[linear-gradient(90deg,#05DF72_0%,#00C950_50%,_#00A63E_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Education Loan</span> Sanction
                Letter
              </>
            ),
          },
        ],
      },

      {
        id: "parent_fund",
        title: "Parent",
        label: "Funds",
        icon: <Parent />,
        lightColor: "bg-[#EBD2FF]",
        bgColor: "bg-[#FAF5FF]",
        gridentColor:
          "bg-[linear-gradient(90deg,#C27AFF_0%,#AD46FF_50%,_#9810FA_100%)]",
        details: [
          {
            id: 1,
            title: (
              <>
                <span className="font-semibold">Savings A/C</span> Balance
                Certificate{" "}
              </>
            ),
          },
          {
            id: 2,
            title: (
              <>
                {" "}
                <span className="font-semibold">Fixed Deposit</span> Balance
                Certificate{" "}
              </>
            ),
          },
          { id: 3, title: "Affidavit" },
          { id: 4, title: "Notarized Person’s Visiting Card" },
          { id: 5, title: "Birth Certificate" },
        ],
      },
    ],
  },
];

export const eventsUniversity = [
  {
    title: "Constructor University",
    value: "f9765650-31d2-4b84-b3c4-703223f0e4a5",
  },
  {
    title: "Birmingham City University",
    value: "9efc6f61-6e0f-4d46-b7e4-37df1d46fe31",
  },
];

export const GlobalSearchFinalDestination = [
  {
    id: 1,
    title: "Australia",
    image: "/assets/images/png/flags/australia.png",
    link: "/country/australia",
  },
  {
    id: 2,
    title: "Canada",
    image: "/assets/images/png/flags/canada.png",
    link: "/country/canada",
  },
  {
    id: 3,
    title: "Europe",
    image: "/assets/images/png/flags/europe.png",
    link: "/all-countries/europe",
  },
  {
    id: 4,
    title: "United Kingdom",
    image: "/assets/images/png/flags/uk.png",
    link: "/country/united-kingdom",
  },
  {
    id: 5,
    title: "United States of America",
    image: "/assets/images/png/flags/usa.png",
    link: "/country/united-states",
  },
];

export const navbarSearchIconProtectedRoutes = ["ai-course-finder", "about-us"];

export const topUniversityHomepage = [
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/sycrase.png",
    college_slug: "/united-states/syracuse-university",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/rensselaer.png",
    college_slug: "/united-states/rensselaer-polytechnic-institute",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/pepperdine.png",
    college_slug: "/united-states/pepperdine-graziadio-business-school",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/akron.png",
    college_slug: "/united-states/university-akron",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/catholic.png",
    college_slug: "/united-states/the-catholic-university-of-america",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/pennstate.png",
    college_slug: "/united-states/penn-state-dickinson-law",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/postuniversity.png",
    college_slug: "/united-states/post-university",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/debrecan.png",
    college_slug: "/hungary/university-of-debrecen",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/constructor.png",
    college_slug: "/germany/constructor-university",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/bathspa.png",
    college_slug: "/united-kingdom/bath-spa-university",
  },
  {
    image:
      "https://storage.googleapis.com/edvia_public_bucket/hero_section_universities/northampton.png",
    college_slug: "/united-kingdom/university-northampton",
  },
];

export const aiCourseFinderTutorialEligibility = [
  {
    id: 1,
    title: "Meet Your Smart Study Abroad Companion",
    description:
      "Discover courses and universities tailored just for you - powered by AI. Get instant, accurate matches based on your profile, goals, and preferences.",
    image: "/assets/gif/aiIntro.gif",
    bg: "",
    mobileImage: "/assets/gif/aiIntro.gif",
  },
  {
    id: 2,
    title: "Choose Where You Dream to Study",
    description:
      "Start by picking your preferred study destination - whether it’s Australia, the UK, Canada, or beyond. Your choice helps us tailor university options that fit you best.",
    image: "/assets/images/png/aiCourseFinder/pickCountry.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/pickCountryMobile.png",
  },
  {
    id: 3,
    title: "Tell Us About Your Academic Backgroud",
    description:
      "Select your latest qualification so we can recommend courses that match your academic level - from diplomas to master’s degrees",
    image: "/assets/images/png/aiCourseFinder/academicDetails.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/academicDetailsMobile.png",
  },
  {
    id: 4,
    title: "Share Your English Test Details",
    description:
      "Choose your test type (IELTS, TOEFL, PTE, etc.) and enter your score. This helps us refine your eligibility and suggest the right universities.",
    image: "/assets/images/png/aiCourseFinder/englishProficiencyDetails.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/englishProficiencyDetailsMobile.png",
  },
  {
    id: 5,
    title: "Explore Your Perfect Courses Matches",
    description:
      "Here’s where the magic happens - view universities, compare courses, and view fees, duration or location. Ready?",
    image: "/assets/images/png/aiCourseFinder/result.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/resultMobile.png",
  },
  {
    id: 6,
    title: "Apply with Confidence",
    description:
      "You're eligible! Apply by dropping in your essential documents to receive your guaranteed offer letter and get ready for your study abroad journey. ",
    image: "/assets/images/png/aiCourseFinder/apply.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/applyNowMobile.png",
  },
];
export const aiCourseFinderTutorialPrograms = [
  {
    id: 1,
    title: "Find Programs You May Be Eligible For",
    description:
      "Go beyond basic searches. Our intelligent AI finder helps you explore thousands of global programs. Simply enter your preferences to get a curated list of your best-fit courses.",
    image: "/assets/gif/aiIntro.gif",
    bg: "",
    mobileImage: "/assets/gif/aiIntro.gif",
  },
  {
    id: 2,
    title: "Select Your Study Destination",
    description:
      "Your global education journey starts here. Begin by choosing the country where you wish to pursue your studies, and we'll unlock a world of opportunities tailored for you.",
    image: "/assets/images/png/aiCourseFinder/pickCountryProgram.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/pickCountryProgramMobile.png",
  },
  {
    id: 3,
    title: "Outline Your Academic Goals",
    description:
      "Specify your desired qualification level, stream of interest, specialization, and preferred intake to help us find programs that may suit your goals.",
    image: "/assets/images/png/aiCourseFinder/searchProgramStudy.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchProgramStudyMobile.png",
  },
  {
    id: 4,
    title: "Discover & Compare Your Matches",
    description:
      "Explore a curated list of programs, view detailed information, and compare your top choices. Found something you like? Check your eligibility instantly to see where you stand.",
    image: "/assets/images/png/aiCourseFinder/searchProgramPerfectMatch.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchProgramPerfectMatchMobile.png",
  },
  {
    id: 5,
    title: "Confirm Your Eligibility Instantly",
    description:
      "Found a program you love? Quickly determine your eligibility! Simply enter your past qualification details and English test scores, and our system will let you know in seconds if you're a perfect match.",
    image:
      "/assets/images/png/aiCourseFinder/searchProgramCheckEligibility.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchProgramCheckEligibilityMobile.png",
  },
  {
    id: 6,
    title: "Apply and Begin Your Journey",
    description:
      "Once you've confirmed you're eligible, the next step is simple. Securely upload your essential documents and submit your application to your dream university with just a few clicks.",
    image: "/assets/images/png/aiCourseFinder/searchProgramApply.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/applyNowMobile.png",
  },
];
export const aiCourseFinderTutorialInstitutes = [
  {
    id: 1,
    title: "Find the University That's Right for You",
    description:
      "Your university is more than just a place to study. Our smart search helps you discover institutions that match your academic ambitions and fit your personal goals.",
    image: "/assets/gif/aiIntro.gif",
    bg: "",
    mobileImage: "/assets/gif/aiIntro.gif",
  },
  {
    id: 2,
    title: "Select Your Study Destination",
    description:
      "Your global education journey starts here. Begin by choosing the country where you wish to pursue your studies, and we'll unlock a world of opportunities tailored for you.",
    image: "/assets/images/png/aiCourseFinder/pickCountryInstitutes.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/pickCountryInstitutesMobile.png",
  },
  {
    id: 3,
    title: "Shape Your University Experience",
    description:
      "Tell us your preferred institute type and intake, and we'll match you with institutes accepting applications for your timeline.",
    image: "/assets/images/png/aiCourseFinder/searchInstitutesLookingFor.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchInstitutesLookingForMobile.png",
  },
  {
    id: 4,
    title: "Explore Your Curated Options",
    description:
      "Based on your choices, here is a tailored list of universities. Delve into what each institution offers, from their academic strengths to campus culture, and start building your shortlist.",
    image: "/assets/images/png/aiCourseFinder/searchInstitutesPerfectMatch.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchInstitutesPerfectMatchMobile.png",
  },
  {
    id: 5,
    title: "Confirm Your Eligibility Instantly",
    description:
      "Found an institution that excites you? It's time to explore its programs. From here, you can easily check your eligibility for a specific course and move forward with your application.",
    image:
      "/assets/images/png/aiCourseFinder/searchInstitutesCheckEligibility.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage:
      "/assets/images/png/aiCourseFinder/searchInstitutesCheckEligibilityMobile.png",
  },
  {
    id: 6,
    title: "Take the Final Step",
    description:
      "Once you've confirmed you're eligible, the next step is simple. Securely upload your essential documents and submit your application to your dream university with just a few clicks.",
    image: "/assets/images/png/aiCourseFinder/searchInstitutesApply.png",
    bg: "/assets/mp4/aiCourseFinderBackground.mp4",
    mobileImage: "/assets/images/png/aiCourseFinder/applyNowMobile.png",
  },
];

export const loadingWithFacts = [
  {
    id: 0,
    title: "Over 5 million students study abroad worldwide each year.",
  },
  {
    id: 1,
    title: "The USA hosts the largest number of international students.",
  },
  {
    id: 2,
    title:
      "Australia has one of the highest post-study work visa durations for graduates—up to 4 years.",
  },
  {
    id: 3,
    title:
      "Canada allows international students to work up to 20 hours per week during semesters.",
  },
  {
    id: 4,
    title:
      "Studying abroad improves job prospects, with 90% of alumni reporting better career opportunities.",
  },
  {
    id: 5,
    title:
      "Students who study abroad improve cross-cultural communication skills by 80%.",
  },
  {
    id: 6,
    title:
      "The UK is home to over 120,000 international students from India alone.",
  },
  {
    id: 7,
    title:
      "New Zealand consistently ranks in the top 10 for student satisfaction.",
  },
  {
    id: 8,
    title:
      "STEM graduates abroad have a higher employment rate within 6 months of graduation than non-STEM.",
  },
  {
    id: 9,
    title:
      "France offers courses in English at over 300 universities, not just in French.",
  },
  {
    id: 10,
    title:
      "On average, international students spend $10,000–$20,000 per year on living expenses, depending on the country.",
  },
  {
    id: 11,
    title:
      "Singapore has one of the lowest student-to-teacher ratios in Asia—around 15:1.",
  },
  {
    id: 12,
    title:
      "Studying abroad increases your global network, often connecting with peers from 50+ countries.",
  },
  {
    id: 13,
    title:
      "More than 50% of students in Europe study courses in English, even if it's not their native language.",
  },
  {
    id: 14,
    title:
      "Students abroad are twice as likely to get leadership roles in international companies.",
  },
  {
    id: 15,
    title:
      "Learning abroad improves adaptability and problem-solving skills, which are top skills employers look for.",
  },
  {
    id: 16,
    title:
      "International students contribute over $300 billion annually to the global economy.",
  },
  {
    id: 17,
    title:
      "Switzerland has one of the highest salaries for graduates in Europe, especially in finance and engineering.",
  },
  {
    id: 18,
    title:
      "Students studying abroad are 30% more likely to speak a second language fluently.",
  },
  {
    id: 19,
    title:
      "International students often find part-time jobs in cafes, libraries, or internships, boosting experience and income.",
  },
  {
    id: 20,
    title:
      "Studying abroad can increase your cultural intelligence, making you more adaptable in diverse workplaces.",
  },
  {
    id: 21,
    title:
      "Italy offers scholarships for students pursuing arts, design, and culinary programs.",
  },
  {
    id: 22,
    title:
      "Spain is home to 50 UNESCO World Heritage sites, perfect for students who love history.",
  },
  {
    id: 23,
    title:
      "Singapore is a hub for business, technology, and research in Asia, attracting thousands of international students.",
  },
  {
    id: 24,
    title:
      "Students who study abroad are more likely to volunteer and participate in social initiatives.",
  },
  {
    id: 25,
    title:
      "Studying abroad improves your critical thinking and independent decision-making skills.",
  },
  {
    id: 26,
    title:
      "Australia has the highest number of student cities ranked in QS Top 50 for quality of life.",
  },
  {
    id: 27,
    title:
      "UK universities often provide dedicated career centers to help international students find jobs after graduation.",
  },
  {
    id: 28,
    title:
      "Over 70% of international students report forming lifelong friendships abroad.",
  },
  {
    id: 29,
    title:
      "Over 90% of Edvia students find courses that match their career goals perfectly.",
  },
  {
    id: 30,
    title:
      "Students using Edvia explore 300+ top universities worldwide before applying.",
  },
  {
    id: 31,
    title:
      "On Edvia, you can compare tuition fees, living costs, and post-study work options in minutes.",
  },
  {
    id: 32,
    title:
      "Edvia helps students find universities with the lowest student-to-teacher ratio for personalised learning.",
  },
  {
    id: 33,
    title:
      "70% of Edvia users discover scholarship opportunities they didn’t know existed.",
  },
  {
    id: 34,
    title:
      "Students using Edvia spend less than 3 mins to shortlist universities instead of weeks of research.",
  },
  {
    id: 35,
    title:
      "Edvia users are 30% more confident in choosing the right course abroad.",
  },
  {
    id: 36,
    title:
      "Edvia provides personalised recommendations based on your profile, stream, and test scores.",
  },
  {
    id: 37,
    title:
      "Edvia tracks your application progress in real time, so nothing gets missed.",
  },
  {
    id: 38,
    title:
      "Students on Edvia explore English-taught programs even in non-English-speaking countries.",
  },
  {
    id: 39,
    title:
      "Edvia highlights top-ranked universities for STEM, Arts, Business, and more.",
  },
  {
    id: 40,
    title:
      "With Edvia, students compare living costs in cities vs. rural areas to plan budgets better.",
  },
  {
    id: 41,
    title:
      "80% of Edvia users explore multiple destinations before finalizing their applications.",
  },
  {
    id: 42,
    title:
      "Edvia helps students identify universities with high international student satisfaction.",
  },
  {
    id: 43,
    title:
      "Students can track scholarship deadlines, exam dates, and course start dates on Edvia.",
  },
  {
    id: 44,
    title:
      "Using Edvia increases your chances of getting admission to your dream university with proper guidance.",
  },
  {
    id: 45,
    title: "Edvia lets you compare 5+ courses in just a few clicks.",
  },
  {
    id: 46,
    title:
      "Students using Edvia explore hidden gem universities beyond the usual top 10 lists.",
  },
  {
    id: 47,
    title:
      "Edvia tracks your eligibility for scholarships based on your grades and profile.",
  },
  {
    id: 48,
    title:
      "Students find their ideal study destinations using Edvia’s AI-powered course finder.",
  },
  {
    id: 49,
    title:
      "Edvia helps you plan your budget, from tuition to living expenses, before applying.",
  },
  {
    id: 50,
    title:
      "Over 60% of Edvia users explore multiple countries before finalizing their choice.",
  },
  {
    id: 51,
    title:
      "Edvia provides real-time updates on your application status, so nothing gets missed.",
  },
  {
    id: 52,
    title:
      "Edvia shows trending courses in emerging fields like AI, Data Science, and Sustainability.",
  },
  {
    id: 53,
    title:
      "Edvia tracks application deadlines,  so you never miss an important date.",
  },
  {
    id: 54,
    title:
      "Students discover full and partial scholarships that cover tuition and living expenses.",
  },
  {
    id: 55,
    title:
      "Edvia users can compare global rankings and alumni outcomes before applying.",
  },
  {
    id: 56,
    title:
      "Students can get instant AI-based course recommendations tailored to their profile.",
  },
  {
    id: 57,
    title:
      "Edvia tracks entry requirements and language test scores for each university.",
  },
  {
    id: 58,
    title:
      "Using Edvia increases your chance of getting into multiple dream universities, thanks to smart recommendations.",
  },
];

export const chatBotSuggestions = [
  {
    label: "Find my best country",
    icon: Globe2,
  },

  {
    label: "Check my eligibility",
    icon: CheckCircle,
  },

  {
    label: "Scholarships for me",
    icon: Wallet,
  },

  {
    label: "Cost & ROI analysis",
    icon: DollarSign,
  },
  {
    label: "Compare universities",
    icon: BarChart,
  },

  {
    label: "Visa documents",
    icon: File,
  },
];
export const roiCardsData = [
  {
    id: 1,
    image: "/assets/images/png/roi/dataScience.png",
    title: "Master's in Data Science",
    description: (
      <>
        Turn vast data into critical business insights and strategic decisions.{" "}
        <span className="text-[#5F58EC] font-semibold">
          Become the expert who predicts market success.
        </span>
      </>
    ),
    label: "Globally Hot: 28% More Students Choose This",
    course: "information_technology",
    company: [
      "/assets/images/png/roi/amazon.png",
      "/assets/images/png/roi/jp.png",
      "/assets/images/png/roi/walmart.png",
      "/assets/images/png/roi/meta.png",
      "/assets/images/png/roi/capitalOne.png",
      "/assets/images/png/roi/microsoft.png",
    ],
    payBackYear: " 0.4",
  },
  {
    id: 2,
    image: "/assets/images/png/roi/mba.png",
    title: "MBA in Marketing",
    description: (
      <>
        Learn to analyze consumer behavior, strategically position products for
        market dominance .{" "}
        <span className="text-[#5F58EC] font-semibold">
          Become the leader who builds iconic brands.
        </span>
      </>
    ),
    course: "information_technology",
    label: "Globally Hot: Digital channels account for 72% of global ad spend.",
    company: [
      "/assets/images/png/roi/siemens.png",
      "/assets/images/png/roi/bmw.png",
      "/assets/images/png/roi/henkel.png",
      "/assets/images/png/roi/adobe.png",
      "/assets/images/png/roi/sap.png",
      "/assets/images/png/roi/beiersdorf.png",
    ],
    payBackYear: " 0.5",
  },
  {
    id: 3,
    image: "/assets/images/png/roi/ai.png",
    title: "Master’s in Artificial Intelligence",
    description: (
      <>
        Harness the power of algorithms to build intelligent systems and drive
        automation.{" "}
        <span className="text-[#5F58EC] font-semibold">
          Become the expert who designs the future.
        </span>
      </>
    ),
    course: "information_technology",
    label: "Globally Hot: AI job growth projected at $15 Trillion globally.",
    company: [
      "/assets/images/png/roi/google.png",
      "/assets/images/png/roi/dyson.png",
      "/assets/images/png/roi/graphcore.png",
      "/assets/images/png/roi/rr.png",
      "/assets/images/png/roi/wayve.png",
      "/assets/images/png/roi/benevolentai.png",
    ],
    payBackYear: " 0.4",
  },
  {
    id: 4,
    image: "/assets/images/png/roi/bachelorScience.png",
    title: "Bachelor of Science",
    description: (
      <>
        Acquire analytical & critical thinking skills, and technical management.{" "}
        <span className="text-[#5F58EC] font-semibold">
          Become the analyst who solves complex problems.
        </span>
      </>
    ),
    course: "information_technology",
    label: "Globally Hot: Over 60% of technical jobs require a B.Sc. degree.",
    company: [
      "/assets/images/png/roi/csiro.png",
      "/assets/images/png/roi/csl.png",
      "/assets/images/png/roi/bhp.png",
      "/assets/images/png/roi/sydney_water.png",
      "/assets/images/png/roi/pfizer.png",
    ],
    payBackYear: "2.18",
  },
];

export const strategicBoardMembers = [
  {
    id: 1,
    name: "Twinkle Sandhu",
    designation: "Director",
    image: "/assets/images/png/about-us/twinkleSandhu.png",
  },

  {
    id: 2,
    name: "Nicholas Phillips",
    designation: "Director of Global Partnerships",
    image: "/assets/images/png/about-us/nicholasPhillips.png",
  },
  {
    id: 3,
    name: "Robert Easen",
    designation: "Director of Global Strategic Alliances",
    image: "/assets/images/png/about-us/robertEasen.png",
  },
  {
    id: 4,
    name: "Somya Sharma",
    designation: "Business Manager",
    image: "/assets/images/png/about-us/somya.png",
  },
];

export const techTeamMembers = [
  {
    id: 1,
    name: "Rajat Dhiman",
    designation: "Junior Full Stack Developer",
    description:
      "Building seamless digital experiences by combining clean frontend interfaces with efficient, scalable backend solutions.",
    image: "/assets/images/png/about-us/rajat.png",
  },
  {
    id: 2,
    name: "Nikhil Mehra",
    designation: "Frontend Developer",
    description:
      "Delivering precision and predictability. Driven by specialised use cases to craft a seamless, user-centric interface.",
    image: "/assets/images/png/about-us/nikhil.png",
  },

  {
    id: 3,
    name: "Pankaj Kumar",
    designation: "Backend Developer",
    description:
      "The architect of the engine. Building the robust, scalable, and high-performance systems that power the entire application.",
    image: "/assets/images/png/about-us/pankaj.png",
  },
  {
    id: 4,
    name: "Adit Choudhary",
    designation: "Data Scientist",
    description:
      "The keeper of insight, transforming vast data into actionable intelligence that keeps the platform updated and data-rich for every user.",
    image: "/assets/images/png/about-us/adit.png",
  },
  {
    id: 5,
    name: "Sneha Bansal",
    designation: "User Experience Designer",
    description:
      "Dedicated to good design practices, they ensure every click feels natural, bridging the gap between user and product with thoughtful, accessible interfaces.",
    image: "/assets/images/png/about-us/sneha.png",
  },
];

export const admissionsTeamMembers = [
  {
    id: 1,
    name: "Dr. Antony Fernando",
    designation: "Director CSR and Strategic Partnerships",
    description:
      "He combines global education expertise and strategic leadership to guide students toward informed, future-ready academic and career pathways.",
    image: "/assets/images/png/about-us/antony.png",
  },
  // {
  //   id: 2,
  //   name: "Tanveer Singh",
  //   designation: "Student Relationship Manager",
  //   description:
  //     "The engine for growth. He excels at managing key relationships to drive student enrolment and secure successful placements for our university partners",
  //   image: "/assets/images/png/about-us/tanveer.png",
  // },

  {
    id: 2,
    name: "Luxmi Puri",
    designation: "Admissions Team Lead",
    description:
      "Leading a diverse, country-specific admissions team, she champions the belief that every application is important, ensuring personalised success for all students.",
    image: "/assets/images/png/about-us/luxmi.png",
  },
  {
    id: 3,
    name: "Gurpreet Singh",
    designation: "Student Relationship Head",
    description:
      "Driving institutional growth by forging strategic global tie-ups, ensuring every partnership opens doors for the next generation of students.",
    image: "/assets/images/png/about-us/Gurpreet.png",
  },
];

export const affilationsPartnerships = [
  {
    id: 1,
    image: "/assets/images/png/about-us/gisma.png",
  },
  {
    id: 2,
    image: "/assets/images/png/about-us/universityEurope.png",
  },
  {
    id: 3,
    image: "/assets/images/png/about-us/hartpury.png",
  },
  {
    id: 4,
    image: "/assets/images/png/about-us/pepperdine.png",
  },
  {
    id: 5,
    image: "/assets/images/png/about-us/post.png",
  },
  {
    id: 6,
    image: "/assets/images/png/about-us/bentley.png",
  },
  {
    id: 7,
    image: "/assets/images/png/about-us/herzing.png",
  },
  {
    id: 8,
    image: "/assets/images/png/about-us/avalon.png",
  },
  {
    id: 9,
    image: "/assets/images/png/about-us/bathSpa.png",
  },
  {
    id: 10,
    image: "/assets/images/png/about-us/canadaWest.png",
  },
  {
    id: 11,
    image: "/assets/images/png/about-us/abertay.png",
  },
  {
    id: 12,
    image: "/assets/images/png/about-us/akron.png",
  },
  {
    id: 13,
    image: "/assets/images/png/about-us/constructor.png",
  },
  {
    id: 14,
    image: "/assets/images/png/about-us/massageTherapy.png",
  },
  {
    id: 15,
    image: "/assets/images/png/about-us/prifysgol.png",
  },
  {
    id: 16,
    image: "/assets/images/png/about-us/alexander.png",
  },
  {
    id: 17,
    image: "/assets/images/png/about-us/stClair.png",
  },
];

export const timelineData = [
  {
    year: 2020,
    title: "Our Beginning",
    points: [
      "The halt of physical admissions accelerated the shift toward virtual education pathways for students and institutions.",
      "This transition drove the development of automated technology to streamline and improve the matching process between students and universities.",
    ],
    img: "/assets/images/png/about-us/2021.png",
  },
  {
    year: 2021,
    title: "Building the Foundation",
    points: [
      "The creation of the [Course Finder](/tools/course-finder) Engine prototype allowed students to instantly match their academic profiles against complex university entry requirements.",
      "This technology transformed the search process by making global education opportunities both accessible and predictable for every applicant.",
    ],
    img: "/assets/images/png/about-us/2022v2.png",
  },
  {
    year: 2022,
    title: "Scaling Intelligence",
    points: [
      "A centralised Data Entry Platform was established to consolidate and structure global university data into a single, unified panel.",
      "This system ensures the Course Finder remains accurate across all academic scenarios, enabling the platform to scale while maintaining comprehensive functionality.",
    ],
    img: "/assets/images/png/about-us/2025v2.png",
  },
  {
    year: 2023,
    title: "Expanding the Ecosystem",
    points: [
      "The Course Finder was officially integrated into Agent and University Partner panels to ensure the authenticity and reliability of all academic data.",
      "A comprehensive CRM Portal was launched to manage the entire ecosystem, streamlining the flow of data and relationships between agents and universities.",
    ],
    img: "/assets/images/png/about-us/2023.png",
  },
  {
    year: 2024,
    title: "Transforming Admissions",
    points: [
      "The Admissions Panel was launched with a built-in Eligibility Checker to automate the student application process from start to finish.",
      "This system handles everything from document verification to providing personalised support for university interview preparation.",
    ],
    img: "/assets/images/png/about-us/2025.png",
  },
  {
    year: 2025,
    title: "Empowering Every Student",
    points: [
      "Development focused on the student end-user to deliver personalised educational opportunities directly to their fingertips.",
      "A proprietary AI Chatbot was engineered to provide global course searches and instant support for all student queries.",
      "These advancements ensure comprehensive global access through intelligent automation and highly personalised recommendations.",
    ],
    img: "/assets/images/png/about-us/2022.png",
  },
];

export const MeetExperts = [
  {
    img: "/assets/images/png/about-us/twinkle.png",
    email: "Director@daltinaiportal.com",
    linkedIn: "https://www.linkedin.com/in/twinkle-sandhu-3595702b9/",
    name: "Twinkle Sandhu",
    designation: "Director",
    description:
      "A leadership visionary committed to building high-performance cultures and driving institutional growth. They focus on empowering teams to challenge the status quo, fostering an environment where innovation thrives and disruptive ideas are brought to life.",
    wordsILive: "The best way to predict the future is to create it",
    bookshelf: [
      "Pathways to Light - a guide to maintaining clarity and purpose in leadership.",
    ],
    offTheClock: [
      "Reading books",
      "Figuring out new ways for better management",
    ],
    smallImageRemovedBg: "/assets/images/png/about-us/twinkleWithoutBg.png",
  },

  // {
  //   img: "/assets/images/png/about-us/nicholas.png",
  //   email: "niko.phillips@daltinedugroup.com",
  //   linkedIn: "https://www.linkedin.com/in/nikophillips/",
  //   name: "Nicholas Philips",
  //   designation: "Director of Global Partnerships",
  //   description:
  //     "A master of connectivity who views every interaction as an opportunity for long-term synergy. They focus on identifying shared values between global entities, crafting sustainable ecosystems that amplify the impact of both parties. Their approach turns the art of negotiation into a science of collaborative success and mutual growth.",
  //   wordsILive:
  //     "There are two kinds of music, good music, and the other kind- Duke Ellington",
  //   bookshelf: ["Helgoland - Carlo Rovelli"],
  //   offTheClock: ["Playing padel or Running"],
  //   smallImageRemovedBg: "/assets/images/png/about-us/nicholasWithoutBg.png",
  // },
  {
    img: "/assets/images/png/about-us/robert.png",
    email: "rob.easen@daltinedugroup.com",
    name: "Robert Easen",
    designation: "Director of Global Alliances",
    description:
      "An architect of high-value ecosystems and deep-level organizational alignment. They specialize in creating synergies between industry leaders and emerging innovators, focusing on building alliances that deliver long-term value and redefine industry standards.",
    wordsILive:
      "Plant your own garden & decorate your own soul, instead of waiting for someone to bring you flowers",
    bookshelf: [
      "The Celestine Prophecy.",
      "Shaolin Spirit: The way to self-mastery.",
    ],
    offTheClock: ["Fostering curiosity in my children."],
    smallImageRemovedBg: "/assets/images/png/about-us/robertWithoutBg.png",
  },
  {
    img: "/assets/images/png/about-us/somyaSharma.png",
    email: "Somya@daltinaiportal.com",
    linkedIn: "https://www.linkedin.com/in/ssomyassharma8/",
    name: "Somya Sharma",
    designation: "Business Manager",
    description:
      "An architect of operational flow who thrives at the intersection of strategy and execution. They are dedicated to building robust internal systems that transform ambitious goals into measurable results. By prioritizing clarity and removing friction, they empower teams to maintain high momentum without sacrificing precision.",
    wordsILive: "If I need the moon, I will bring it down myself",
    bookshelf: [
      "Unconscious: Sigmund Freud",
      "The EGO and the ID: Sigmund Freud",

      "Like the Flowing River: Paulo Coelho",
    ],
    offTheClock: [
      "Lifting weights at the gym",
      "Reading in some coffee shop",
      "Running around lake/ beach",
    ],
    smallImageRemovedBg: "/assets/images/png/about-us/somyaWithoutBg.png",
  },
];

export const trustAndTransparency = [
  {
    name: "data",
    items: [
      { name: "GDPR Privacy Policy", url: "/gdpr-privacy-policy" },
      { name: "Data Processing Agreement", url: "/data-processing-agreement" },
      { name: "Cookie Policy", url: "/cookie-policy" },
    ],
  },
  {
    name: "internal",
    items: [
      {
        name: "Information Security Policy",
        url: "/information-security-policy",
      },
      {
        name: "Record of Processing Activity",
        url: "/record-of-processing-activity",
      },
      { name: "Data Breach Policy", url: "/data-breach-policy" },
    ],
  },
  {
    name: "governance",
    items: [
      {
        name: "Data Retention &  Deletion Policy",
        url: "/data-retention-deletion-policy",
      },
      {
        name: "Vendor Compliance Checklist",
        url: "/vendor-compliance-checklist",
      },
      {
        name: "Employee Confidentiality Agreement",
        url: "/employee-confidentiality-agreement",
      },
    ],
  },
];

export const UniversitiesSolutionsDetails = [
  {
    id: 1,
    icon: <SecorityIcon />,
    name: "Verified Applications",
    description:
      "Receive students who are pre-screened for eligibility. Our platform filters out unqualified applicants before they reach your desk.",
  },
  {
    id: 2,
    icon: <DocumentIcon />,
    name: "Document Forensics",
    description:
      "Protect your institution with automated checks. Our hybrid engine detects document irregularities and ensures every file is authentic and auditable.",
  },
  {
    id: 3,
    icon: <PiChartIcon />,
    name: "Real-Time Admissions Dashboard",
    description:
      "Track your recruitment funnel in one place. Monitor application statuses, document progress, and enrollment trends with live data to make faster, more informed admissions decisions.",
  },
  {
    id: 4,
    icon: <GreenClockIcon />,
    name: "24/7 Global Support",
    description:
      "Access round-the-clock assistance. We provide constant support for your team and students, paired with local insights to help you navigate diverse international markets.",
  },
];
export const StudentSolutionsDetails = [
  {
    id: 1,
    icon: <DocumentIcon />,
    name: "Smart Course Matching",
    description:
      "Match your academic background with programs you are eligible for in seconds. Apply only to courses where you meet the stated criteria.",
  },
  {
    id: 2,
    icon: <GreenPercent />,
    name: "Scholarship Opportunities",
    description:
      "Discover programs with financial aid. Filter and search for courses that offer integrated scholarship opportunities to help fund your education from the start.",
  },
  {
    id: 3,
    icon: <GreenClockIcon />,
    name: "Real - Time Progress Tracking",
    description:
      "Stay informed at every stage. From document review to application submission, you’ll always know exactly where you stand.",
  },
  {
    id: 4,
    icon: <GreenAirplaneIcon />,
    name: "Visa & Arrival Support",
    description:
      "Navigate your journey with confidence. We provide expert help with your visa filing, pre-departure prep, and on-ground services to ensure you settle in smoothly.",
  },
];

export const conversionCards = [
  {
    title: "CGPA to GPA Conversion",
    formula: "GPA = (CGPA ÷ 10) × 4.0",
    note: "For 10-point CGPA scale",
    examples: [
      ["9.5 CGPA", "3.8 GPA"],
      ["8.5 CGPA", "3.4 GPA"],
      ["7.0 CGPA", "2.8 GPA"],
    ],
  },
  {
    title: "GPA to CGPA Conversion",
    formula: "CGPA = (GPA ÷ 4.0) × 10",
    note: "For 4-point GPA scale",
    examples: [
      ["4.0 GPA", "10.0 CGPA"],
      ["3.5 GPA", "8.75 CGPA"],
      ["3.0 GPA", "7.5 CGPA"],
    ],
  },
];

export const principles = [
  {
    icon: <CheckIcon />,
    title: "Proportional Method",
    desc: "We use the proportional conversion method that maintains the relative standing of your academic performance across different scales.",
  },
  {
    icon: <GlobeIcon />,
    title: "Globally Recognized",
    desc: "Our conversion standards are accepted by universities in USA, UK, Canada, Australia, Germany, and 50+ other countries.",
  },
  {
    icon: <SlidersHorizontalIcon />,
    title: "Precision & Accuracy",
    desc: "We maintain two decimal places for precision, ensuring your converted score accurately reflects your academic excellence.",
  },
];

export const courseLeadsCurriculum = [
  {
    id: 1,
    title: "Industry-Relevant Curriculum",
    description:
      "Learn from updated course content aligned with market demands",
    icon: <BookOpen color="white" />,
  },
  {
    id: 2,
    title: "Expert Faculty",
    description: "World-class professors with real-world business experience",
    icon: <Users2 color="white" />,
  },
  {
    id: 3,
    title: "Global Recognition",
    description: "Degree recognized by employers and institutions worldwide",
    icon: <Award color="white" />,
  },
  {
    id: 4,
    title: "Career Growth",
    description: "Strong placement support and alumni network",
    icon: <TrendingUp color="white" />,
  },
];

export const states = [
  {
    id: "jalandhar",
    name: "Jalandhar",
    tag: "Punjab",
    desc: "The city of open hand — heart of Punjabi spirit, sports, and centuries of vibrant cultural legacy.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Open_Hand_Monument_Chandigarh_2014.jpg/800px-Open_Hand_Monument_Chandigarh_2014.jpg",
  },
  {
    id: "delhi",
    name: "Delhi NCR",
    tag: "Capital",
    desc: "Millennia of empire and reinvention — Mughal grandeur fused with roaring cosmopolitan energy.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/India_Gate_in_New_Delhi_03-2016.jpg/800px-India_Gate_in_New_Delhi_03-2016.jpg",
  },
  {
    id: "jaipur",
    name: "Jaipur",
    tag: "Rajasthan",
    desc: "The Pink City rises from the Thar — jewelled amber forts, royal bazaars, timeless Rajput heritage.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Hawa_Mahal_Jaipur_Rajasthan_India.jpg/800px-Hawa_Mahal_Jaipur_Rajasthan_India.jpg",
  },
  {
    id: "gujarat",
    name: "Gujarat",
    tag: "West India",
    desc: "Salt flats of Kutch, Gir lions, ancient trade routes — Gujarat reveals itself in breathtaking layers.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Rann_of_Kutch.jpg/800px-Rann_of_Kutch.jpg",
  },
  {
    id: "maharashtra",
    name: "Maharashtra",
    tag: "West India",
    desc: "Bollywood's glitter, the silence of Ajanta caves, and an endless sun-baked Arabian coastline.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Mumbai_03-2016_30_Gateway_of_India.jpg/800px-Mumbai_03-2016_30_Gateway_of_India.jpg",
  },
  {
    id: "telangana",
    name: "Telangana",
    tag: "South India",
    desc: "Pearls and biryani, Nizami grandeur, and the rise of a booming technology corridor in Hyderabad.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Charminar_Evening.jpg/800px-Charminar_Evening.jpg",
  },
  {
    id: "karnataka",
    name: "Karnataka",
    tag: "South India",
    desc: "Silicon Valley of India — wrapped in misty coffee estates and the ruins of Vijayanagara empire.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Hampi_Virupaksha_Temple_2.jpg/800px-Hampi_Virupaksha_Temple_2.jpg",
  },
  {
    id: "tamilnadu",
    name: "Tamil Nadu",
    tag: "South India",
    desc: "Dravidian civilization alive — towering gopurams pierce the sky along an eternal Coromandel coast.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Meenakshi_amman_temple_Madurai.jpg/800px-Meenakshi_amman_temple_Madurai.jpg",
  },
  {
    id: "kerala",
    name: "Kerala",
    tag: "South India",
    desc: "God's Own Country — backwaters shimmer with gold, spices perfume the breeze, time drifts gently.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Kerala_backwater.jpg/800px-Kerala_backwater.jpg",
  },
];
export type State = (typeof states)[0];

export const locations = [
  {
    id: "tricity",
    name: "TRICITY",
    image: "/assets/images/png/canter-event/indiaTour/triCity.png",
    title: "Tricity - The Gateway",
    description:
      "Integrating the architectural precision of Chandigarh with the rising urban energy of Mohali and Panchkula’s serene landscapes.",
    milestone: "Milestone 1",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "jalandhar",
    name: "JALANDHAR",
    image: "/assets/images/png/canter-event/indiaTour/lpu.png",
    title: "Jalandhar - The Heartland",
    description:
      "Jalandhar Compare market exports, apply through heritage, and fly onto the factory floors where global sports trade truly happens.",
    milestone: "Milestone 2",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "delhi-ncr",
    name: "DELHI NCR",
    image: "/assets/images/png/canter-event/indiaTour/delhi.png",
    title: "Delhi NCR - The Capital Nexus",
    description:
      "Delhi NCR Compare power dynamics, apply via policy, and fly into the diplomatic summits where international business truly happens.",
    milestone: "Milestone 3",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "jaipur",
    name: "JAIPUR",
    image: "/assets/images/png/canter-event/indiaTour/jaipur.png",
    title: "Rajasthan - The Royal Frontier",
    description:
      "A majestic expanse defined by the golden sands of the Thar and the industrious spirit of India’s most prosperous western coast.",
    milestone: "Milestone 4",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "gujarat",
    name: "GUJARAT",
    image: "/assets/images/png/canter-event/indiaTour/guj.png",
    title: "Gujarat - The Heritage Powerhouse",
    description:
      "A grand synthesis of timeless desert tradition and the high-octane enterprise of India’s western gateway",
    milestone: "Milestone 5",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "maharashtra",
    name: "MAHARASHTRA",
    image: "/assets/images/png/canter-event/indiaTour/mahara.png",
    title: "Maharashtra - The Economic Core",
    description:
      "The powerhouse of the Indian economy, blending the glitz of the financial capital with a rich legacy of Sahyadri mountain history.",
    milestone: "Milestone 6",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "telangana",
    name: "TELANGANA",
    image: "/assets/images/png/canter-event/indiaTour/telanagana.png",
    title: "Telangana - The Tech Plateau",
    description:
      "A sophisticated landscape where the iconic Charminar gazes upon the shimmering glass towers of a global technology revolution.",
    milestone: "Milestone 7",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "karnataka",
    name: "KARNATAKA",
    image: "/assets/images/png/canter-event/indiaTour/karnataka.png",
    title: "Karnataka - The Silicon Sphere",
    description:
      "The innovative garden of India, where high-altitude greenery meets the cutting-edge research and development of the digital age.",
    milestone: "Milestone 8",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "andhra-pradesh",
    name: "Andhra Pradesh",
    image: "/assets/images/png/canter-event/indiaTour/andhara.png",
    title: "Andhra Pradesh - The Sunrise Sector",
    description:
      "A diverse coastal region bridging the gap between ancient temple grandeur and the modern vision of a developing industrial future.",
    milestone: "Milestone 10",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "tamil-nadu",
    name: "TAMIL NADU",
    image: "/assets/images/png/canter-event/indiaTour/tamilNadu.png",
    title: "Tamil Nadu- The Heritage Node",
    description:
      "The soulful guardian of Dravidian art, where temple bells echo alongside the hum of massive manufacturing and automotive hubs.",
    milestone: "Milestone 9",
    viewDetailsUrl: "/india-tour/tricity",
  },
  {
    id: "kerala",
    name: "KERALA",
    image: "/assets/images/png/canter-event/indiaTour/ker.png",
    title: "Kerala- The Emerald Waypoint",
    description:
      "A serene journey through the backwaters of God’s Own Country offering a peaceful conclusion amidst tropical spice plantations.",
    milestone: "Milestone 11",
    viewDetailsUrl: "/india-tour/tricity",
  },
];

export const HeroUniversities = [
  {
    name: "Durham University, UK",
    country: "",
    program: ["Study AI", "Master’s", "MBA", "Engineering"],
    ranking: "Russell Group",
    qualified: true,
    scholarship: "₹ 12L",
    image: "/assets/images/png/homepage/durham_university.png",
    qsRanking: "94",
  },
  {
    name: "University of Manchester,UK",
    country: "",
    program: ["Computer Science", "PhD", "Data Science"],
    ranking: "Russell Group",
    qualified: true,
    scholarship: "$55K",
    image: "/assets/images/png/homepage/manchester_university.png",
    qsRanking: "35",
  },
  {
    name: "Kings College London, UK",
    country: "",
    program: ["Bachelor’s", "MSc", "Information Technology"],
    ranking: "Russell Group",
    qualified: true,
    scholarship: "₹ 9.5L",
    image: "/assets/images/png/homepage/kings_university.png",
    qsRanking: "31",
  },
  {
    name: "Cardiff University, UK",
    country: "",
    program: [
      "Data Analytics",
      "Master’s",
      "Master’s",
      "Business Intelligence",
    ],
    ranking: "Russell Group",
    qualified: true,
    scholarship: " 35K",
    image: "/assets/images/png/homepage/cardiff_university.png",
    qsRanking: "180+",
  },
  {
    name: "University of Leeds, UK",
    country: "",
    program: ["Robotics", "Bachelor’s", "MBA"],
    ranking: "Russell Group",
    qualified: true,
    scholarship: "$48K",
    image: "/assets/images/png/homepage/leeds_university.png",
    qsRanking: "86",
  },
];

export const PTE_CENTERS: {
  group: string;
  options: { label: string; value: string }[];
}[] = [
    {
      group: "Punjab",
      options: [
        {
          value: "Pearson Professional Centers-Mohali 1",
          label: "Pearson Professional Centers-Mohali 1 – Mohali",
        },
        {
          value: "Pearson Professional Centers-Mohali 2",
          label: "Pearson Professional Centers-Mohali 2 – Mohali",
        },
        {
          value: "Gian Jyoti Institute of Management & Technology - 1",
          label: "Gian Jyoti Institute of Mgmt & Technology – Mohali",
        },
        {
          value: "Multani Mal Modi College, Patiala",
          label: "Multani Mal Modi College – Patiala",
        },
        { value: "HCL Tech - Barnala", label: "HCL Tech – Barnala" },
        {
          value: "Touchstone Educationals LLP",
          label: "Touchstone Educationals LLP – Jalandhar",
        },
        {
          value: "Pearson Professional Centers-Jalandhar 2 PUN",
          label: "Pearson Professional Centers-Jalandhar 2 – Jalandhar",
        },
        {
          value: "Pearson Professional Centers-Jalandhar PUN",
          label: "Pearson Professional Centers-Jalandhar – Jalandhar",
        },
        { value: "HCL Tech - Bathinda", label: "HCL Tech – Bathinda" },
        { value: "HCL Tech. - Firozpur", label: "HCL Tech – Firozpur" },
        {
          value: "Pearson Professional Centers-Amritsar 2 PUN",
          label: "Pearson Professional Centers-Amritsar 2 – Amritsar",
        },
        {
          value: "Pearson Professional Centers-Amritsar PUN",
          label: "Pearson Professional Centers-Amritsar – Amritsar",
        },
        {
          value: "Pearson Professional Centers-Ludhiana",
          label: "Pearson Professional Centers-Ludhiana – Ludhiana",
        },
      ],
    },
    {
      group: "Chandigarh",
      options: [
        {
          value: "Kangaroo Studies Pvt. Ltd.",
          label: "Kangaroo Studies Pvt. Ltd. – Chandigarh",
        },
        {
          value: "Pearson Professional Centers-Chandigarh PUN",
          label: "Pearson Professional Centers-Chandigarh – Chandigarh",
        },
        { value: "Target Consultancy", label: "Target Consultancy – Chandigarh" },
      ],
    },
    {
      group: "Haryana",
      options: [
        { value: "HCL Tech - Ambala", label: "HCL Tech – Ambala Cantt" },
        { value: "HCL Tech - Kurukshetra", label: "HCL Tech – Kurukshetra" },
        {
          value: "Budha Group of Institution - City Center",
          label: "Budha Group of Institution – Karnal",
        },
        { value: "HCL Tech. - Sirsa", label: "HCL Tech – Sirsa" },
        {
          value: "Pearson Professional Centers-Gurugram HAR",
          label: "Pearson Professional Centers-Gurugram – Gurugram",
        },
      ],
    },
    {
      group: "Delhi / NCR",
      options: [
        {
          value: "Pearson Professional Centers-New Delhi",
          label: "Pearson Professional Centers-New Delhi – New Delhi",
        },
        {
          value: "Global Opportunities Pvt Ltd",
          label: "Global Opportunities Pvt Ltd – New Delhi",
        },
        {
          value: "Pearson Professional Centers-Noida",
          label: "Pearson Professional Centers-Noida – Noida, UP",
        },
      ],
    },
    {
      group: "Jammu & Kashmir",
      options: [
        { value: "HCL Tech - Jammu", label: "HCL Tech – Trikuta Nagar, Jammu" },
      ],
    },
    {
      group: "Uttarakhand",
      options: [
        {
          value: "MAYA DEVI UNIVERSITY",
          label: "Maya Devi University – Dehradun",
        },
      ],
    },
    {
      group: "Rajasthan",
      options: [
        { value: "HCL Tech- Sri Ganganagar", label: "HCL Tech – Sri Ganganagar" },
        {
          value: "Yagyavalkya Institute of Technology",
          label: "Yagyavalkya Institute of Technology – Jaipur",
        },
      ],
    },
    {
      group: "Maharashtra",
      options: [
        {
          value: "Pearson Professional Centers-Mumbai",
          label: "Pearson Professional Centers-Mumbai – Mumbai",
        },
        {
          value: "Pearson Professional Centers-Pune MAH",
          label: "Pearson Professional Centers-Pune – Pune",
        },
      ],
    },
    {
      group: "Gujarat",
      options: [
        {
          value: "Bhagwan Mahavir University",
          label: "Bhagwan Mahavir University – Surat",
        },
        { value: "AURO University", label: "AURO University – Surat" },
        {
          value: "Pearson Professional Centers-Surat GUJ",
          label: "Pearson Professional Centers-Surat – Surat",
        },
        { value: "HCL Tech - Anand", label: "HCL Tech – Anand" },
        {
          value: "Trans Globe Education",
          label: "Trans Globe Education – Rajkot",
        },
        {
          value: "Shri Labhubhai Trivedi Institute of Eng and Tech",
          label: "Shri Labhubhai Trivedi Inst. of Eng & Tech – Rajkot",
        },
        {
          value: "Pearson Professional Centers-Ahmedabad GUJ",
          label: "Pearson Professional Centers-Ahmedabad – Ahmedabad",
        },
        {
          value: "Swarnim Startup and Innovation University",
          label: "Swarnim Startup & Innovation University – Ahmedabad",
        },
        { value: "Take Off Academy", label: "Take Off Academy – Ahmedabad" },
        {
          value: "GANPAT UNIVERSITY- CITY OFFICE",
          label: "Ganpat University City Office – Ahmedabad",
        },
        { value: "Ganpat University", label: "Ganpat University – Mehsana" },
      ],
    },
    {
      group: "Telangana",
      options: [
        {
          value: "Pearson Professional Centers-Hyderabad",
          label: "Pearson Professional Centers-Hyderabad – Hyderabad",
        },
      ],
    },
    {
      group: "Madhya Pradesh",
      options: [
        {
          value: "Madan Maharaj College",
          label: "Madan Maharaj College – Bhopal",
        },
      ],
    },
    {
      group: "Karnataka",
      options: [
        {
          value: "Pearson Professional Centers-Bangalore 2 KAR",
          label: "Pearson Professional Centers-Bangalore 2 – Bangalore",
        },
        {
          value: "Pearson Professional Centers-Bangalore",
          label: "Pearson Professional Centers-Bangalore – Bangalore",
        },
        { value: "TCGLOBAL", label: "TCGLOBAL – Bangalore" },
      ],
    },
    {
      group: "Andhra Pradesh",
      options: [
        { value: "K L University", label: "K L University – Vijayawada" },
        {
          value: "SRINIVASA INSTITUTE OF MANAGEMENT STUDIES (SIMS)",
          label: "Srinivasa Institute of Mgmt Studies – Visakhapatnam",
        },
      ],
    },
    {
      group: "Tamil Nadu",
      options: [
        {
          value: "RVS College of Arts and Science",
          label: "RVS College of Arts and Science – Coimbatore",
        },
        {
          value: "Pearson Professional Centers-Chennai",
          label: "Pearson Professional Centers-Chennai – Chennai",
        },
      ],
    },
    {
      group: "Kerala",
      options: [
        {
          value: "Santa Monica Study Abroad Pvt Ltd",
          label: "Santa Monica Study Abroad – Cochin",
        },
        {
          value: "Muthoot Institute of Technology & Science - Site 1",
          label: "Muthoot Inst. of Technology & Science (Site 1) – Cochin",
        },
        {
          value: "Muthoot Institute of Technology & Science - Site 2",
          label: "Muthoot Inst. of Technology & Science (Site 2) – Cochin",
        },
      ],
    },
  ];

export const IELTS_CENTERS: {
  group: string;
  options: { label: string; value: string }[];
}[] = [
    {
      group: "Delhi / NCR",
      options: [
        {
          value: "British Council - New Delhi",
          label: "British Council – New Delhi",
        },
        {
          value: "IDP IELTS - New Delhi (Connaught Place)",
          label: "IDP IELTS – New Delhi (Connaught Place)",
        },
        { value: "IDP IELTS - Noida", label: "IDP IELTS – Noida" },
        { value: "IDP IELTS - Gurugram", label: "IDP IELTS – Gurugram" },
      ],
    },
    {
      group: "Punjab / Chandigarh",
      options: [
        {
          value: "British Council - Chandigarh",
          label: "British Council – Chandigarh",
        },
        { value: "IDP IELTS - Chandigarh", label: "IDP IELTS – Chandigarh" },
        { value: "IDP IELTS - Ludhiana", label: "IDP IELTS – Ludhiana" },
        { value: "IDP IELTS - Amritsar", label: "IDP IELTS – Amritsar" },
        { value: "IDP IELTS - Jalandhar", label: "IDP IELTS – Jalandhar" },
      ],
    },
    {
      group: "Uttarakhand",
      options: [{ value: "IDP IELTS - Dehradun", label: "IDP IELTS – Dehradun" }],
    },
    {
      group: "Rajasthan",
      options: [
        { value: "IDP IELTS - Jaipur", label: "IDP IELTS – Jaipur" },
        { value: "IDP IELTS - Jodhpur", label: "IDP IELTS – Jodhpur" },
      ],
    },
    {
      group: "Maharashtra",
      options: [
        { value: "British Council - Mumbai", label: "British Council – Mumbai" },
        {
          value: "IDP IELTS - Mumbai (Andheri)",
          label: "IDP IELTS – Mumbai (Andheri)",
        },
        { value: "British Council - Pune", label: "British Council – Pune" },
        { value: "IDP IELTS - Pune", label: "IDP IELTS – Pune" },
        { value: "IDP IELTS - Nagpur", label: "IDP IELTS – Nagpur" },
      ],
    },
    {
      group: "Gujarat",
      options: [
        {
          value: "British Council - Ahmedabad",
          label: "British Council – Ahmedabad",
        },
        { value: "IDP IELTS - Ahmedabad", label: "IDP IELTS – Ahmedabad" },
        { value: "IDP IELTS - Surat", label: "IDP IELTS – Surat" },
        { value: "IDP IELTS - Rajkot", label: "IDP IELTS – Rajkot" },
        { value: "IDP IELTS - Vadodara", label: "IDP IELTS – Vadodara" },
      ],
    },
    {
      group: "Karnataka",
      options: [
        {
          value: "British Council - Bangalore",
          label: "British Council – Bangalore",
        },
        { value: "IDP IELTS - Bangalore", label: "IDP IELTS – Bangalore" },
      ],
    },
    {
      group: "Telangana",
      options: [
        {
          value: "British Council - Hyderabad",
          label: "British Council – Hyderabad",
        },
        { value: "IDP IELTS - Hyderabad", label: "IDP IELTS – Hyderabad" },
      ],
    },
    {
      group: "Tamil Nadu",
      options: [
        {
          value: "British Council - Chennai",
          label: "British Council – Chennai",
        },
        { value: "IDP IELTS - Chennai", label: "IDP IELTS – Chennai" },
        { value: "IDP IELTS - Coimbatore", label: "IDP IELTS – Coimbatore" },
      ],
    },
    {
      group: "Kerala",
      options: [
        { value: "IDP IELTS - Kochi", label: "IDP IELTS – Kochi" },
        { value: "IDP IELTS - Trivandrum", label: "IDP IELTS – Trivandrum" },
        { value: "IDP IELTS - Calicut", label: "IDP IELTS – Calicut" },
      ],
    },
    {
      group: "Andhra Pradesh",
      options: [
        { value: "IDP IELTS - Vijayawada", label: "IDP IELTS – Vijayawada" },
        {
          value: "IDP IELTS - Visakhapatnam",
          label: "IDP IELTS – Visakhapatnam",
        },
      ],
    },
    {
      group: "West Bengal",
      options: [
        {
          value: "British Council - Kolkata",
          label: "British Council – Kolkata",
        },
        { value: "IDP IELTS - Kolkata", label: "IDP IELTS – Kolkata" },
      ],
    },
    {
      group: "Madhya Pradesh",
      options: [
        { value: "IDP IELTS - Bhopal", label: "IDP IELTS – Bhopal" },
        { value: "IDP IELTS - Indore", label: "IDP IELTS – Indore" },
      ],
    },
  ];

export const courseFinderProgress = [
  {
    id: "qualification",
    title: "Your Past Qualification",
    description:
      "Your education level helps us curate degree options tailored specifically to your academic journey.",
  },
  {
    id: "stream",
    title: "What is your past qualification stream?",
    description:
      "So we can align courses with your unique background.",
  },
  {
    id: "academic-score",
    title: "What is your pass out year and overall percentage?",
    description:
      "To handpick universities and align courses that match your unique profile, eligibility, and timeline.",
  },
  {
    id: "english-proficiency",
    title: "Have you taken an English proficiency test?",
    description:
      "This helps us verify your eligibility against international university requirements.",
  },
  {
    id: "country-preference",
    title: "Do you have any country preference?",
    description:
      "Tell us where you’d like to go so we can filter universities in your dream locations.",
  },
];

export const courseFinderCountryQuizProgress = [
  {
    id: "what-do-you-want-to-study",
    title: "What would you like to study now?",
  },
  {
    id: "yearly-budget",
    title: "What is your overall budget for tuition and living expenses?",
  },
  {
    id: "main-plan",
    title: "What's more important to you?",
  },
  {
    id: "part-time-job",
    title: "Do you want to work part-time while studying to support expenses?",
  },
  {
    id: "priority",
    title: "Which is your priority?",
  },
  {
    id: "funding",
    title: "Who is funding your studies?",
  },
  {
    id: "post-study-work",
    title: "How important is post-study work?",
  },
];
